// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T21:09:37.684Z
// Property: Harbin Pointe Apartment Homes (ID: 6767906449167212)
// Collections: 25 amenities, 6 floorplans (live), 25 photos, 72 POIs, 4 reviews, 6 virtual tours, 5 office hours, 1 special offers (live), 5 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167212",
  "property_external_id": "1440846",
  "property_zillow_url": "https://www.zillow.com/b/harbin-pointe-bentonville-ar-BScnL7/",
  "property_apartments_url": "https://www.apartments.com/harbin-pointe-apartment-homes-bentonville-ar/rj2xrz2/",
  "property_google_business_url": "https://www.google.com/maps/place/Harbin+Pointe/data=!4m2!3m1!1s0x0:0xffd282b17ec56627?sa=X&ved=2ahUKEwj1zsSlhISTAxXD8MkDHe2rGdgQ_BJ6BAg6EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "harbin-pointe-apartment-homes",
  "property_name": "Harbin Pointe Apartment Homes",
  "property_website_url": "https://www.harbinpointebentonville.com/",
  "property_domain": "https://www.harbinpointebentonville.com/",
  "property_address": "3201 SW Harbin Ave",
  "property_full_address": "3201 SW Harbin Ave, Bentonville, AR 72713",
  "property_address_1": "3201 SW Harbin Ave",
  "property_address_2": null,
  "property_address_city": "Bentonville",
  "property_address_state": "AR",
  "property_address_zip_full": null,
  "property_address_zip": "72713",
  "property_address_country": "US",
  "property_address_county": "Benton County",
  "property_neighborhood_address": "Outer Central Benton County",
  "property_address_latitude": "36.3345001",
  "property_address_longitude": "-94.2488877",
  "property_email": "harbinpointe@weidner.com",
  "property_phone": "4795526614",
  "property_call_tracking_phone": "479-802-0445",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Harbin Pointe in Bentonville, AR, vibrant living meets modern comfort. Choose from spacious one- and two-bedroom floor plans, complete with vaulted ceilings and natural light. Enjoy amenities like a refreshing pool, fitness center, and pet-friendly spaces. Your extraordinary home awaits—browse apartments or schedule a tour today!",
  "property_long_description": "**Welcome to Harbin Pointe – Your Dream Apartment Community in Bentonville, AR!**\n\nAt Harbin Pointe, we pride ourselves on offering a lifestyle that perfectly blends comfort, convenience, and community. Nestled in the heart of Bentonville, our thoughtfully designed one-bedroom and two-bedroom floor plans cater to a variety of needs and preferences. Each apartment features modern amenities such as high-speed internet access, in-home washer/dryer units, and available upgrades like beautifully vaulted ceilings and wood-style vinyl flooring.\n\nOur community isn’t just about the apartments – it’s about the lifestyle we promote. Enjoy 24-hour access to a range of exceptional amenities, including a state-of-the-art fitness center, a refreshing pool, and scenic walking/biking trails that weave through our picturesque grounds. Let your furry friends romp freely in our off-leash bark park or unwind in our beautiful picnic area complete with grilling stations by the serene pond.\n\nEngage in social activities planned regularly in our welcoming clubhouse, which also features a cozy coffee/tea bar and business center for your convenience. Benefit from online services, including easy rent payments and maintenance requests at your fingertips. With ample storage options, available attached and detached garages, and our pet-friendly environment, we have everything you need to make Harbin Pointe feel like home!\n\nDon't miss out on your chance to experience the best in Bentonville living. **Find your new home today – browse our availability or schedule a tour to visit our community!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-0489-703a-962e-1a29e6d60291.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with gray sofa, accent chairs, coffee table, and artwork.",
    "public_id": "019fb1aa-0489-703a-962e-1a29e6d60291",
    "storage_key": "property/6767906449167212/019fb1aa-0489-703a-962e-1a29e6d60291.webp",
    "width": 2752,
    "height": 1536
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "194",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": "6",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.81443298969072",
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": "$400 refundable deposit per household.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://harbinpointebentonville.securecafe.com/onlineleasing/harbin-pointe-0/floorplans.aspx",
  "property_resident_portal_url": "https://harbinpointebentonville.securecafenet.com/residentservices/harbin-pointe-0/userlogin",
  "property_apply_now_url": "https://harbinpointebentonville.securecafe.com/onlineleasing/harbin-pointe-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-047e-717a-8075-ca5ce93318ed.webp",
  "property_primary_logo_media": {
    "alt_text": "Harbin Pointe Apartment Homes logo",
    "public_id": "019d0223-047e-717a-8075-ca5ce93318ed",
    "storage_key": "property/6767906449167212/019d0223-047e-717a-8075-ca5ce93318ed.webp",
    "width": 3000,
    "height": 883
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019f3979-9c8e-77bb-93bd-a1f4f161d9a0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Domain Companies logo.",
    "public_id": "019f3979-9c8e-77bb-93bd-a1f4f161d9a0",
    "storage_key": "property/6767906449167212/019f3979-9c8e-77bb-93bd-a1f4f161d9a0.webp",
    "width": 1280,
    "height": 376
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019f3979-8ff4-745f-8605-9f1453edc218.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Logo",
    "public_id": "019f3979-8ff4-745f-8605-9f1453edc218",
    "storage_key": "property/6767906449167212/019f3979-8ff4-745f-8605-9f1453edc218.webp",
    "width": 1280,
    "height": 376
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#9c5a42",
  "property_secondary_color": "#5f3728",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#c79a80",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "660 - 960",
  "property_sqft_min": "660",
  "property_sqft_max": "960",
  "property_price_range": "1074 - 2335",
  "property_price_min": "1074",
  "property_price_max": "2335",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/harbinpointeapartments",
  "property_instagram_url": "https://www.instagram.com/harbinpointeapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJBayBRcEPyYcRJ2bFfrGC0v8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Harbin Pointe",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Home",
  "property_home_amenities_blurb": "Welcome to Harbin Pointe in Bentonville, AR, where comfort meets lifestyle. Choose from spacious one or two-bedroom floor plans, complemented by exceptional amenities like a refreshing pool, a fitness center, and an off-leash bark park. Dive into a vibrant community with social activities and beautiful views, all designed for modern living.",
  "property_home_floorplans_blurb": "At Harbin Pointe in Bentonville, AR, we offer an array of thoughtfully designed floor plans that blend style and comfort. Each apartment invites you to experience a unique lifestyle tailored just for you. Browse our available homes today and uncover the perfect space that truly feels like home.",
  "property_home_gallery_blurb": "At Harbin Pointe in Bentonville, AR, we offer a vibrant community where modern living meets endless comfort. From stunning one and two-bedroom floor plans to an array of top-tier amenities—like a refreshing pool, serene pond, and vibrant fitness center—your ideal lifestyle awaits. Picture yourself thriving in this enchanting haven!",
  "property_home_neighborhood_blurb": "At Harbin Pointe in Bentonville, AR, your new home is surrounded by vibrant culture and adventure. Enjoy the artistic wonders at Crystal Bridges Museum, unleash your creativity at the Scott Family Amazeum, and embrace the great outdoors at Coler Mountain Bike Preserve. Dive into a community that celebrates both relaxation and excitement!",
  "property_home_reviews_blurb": "At Harbin Pointe in Bentonville, AR, residents rave about the \"friendly atmosphere and attentive management.\" Experience a vibrant community that prioritizes your comfort and happiness. Join us today and see what our residents have to say about living at our welcoming home sweet home!",
  "property_neighborhood_blurb": "At Harbin Pointe in Bentonville, AR, lifestyle meets convenience. Experience the vibrancy of nearby attractions like the Crystal Bridges Museum of American Art and the enchanting Scott Family Amazeum. Enjoy nature trails at Slaughter Pen or a workout at Planet Fitness—your perfect urban oasis awaits. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Harbin Pointe in Bentonville, AR, the perfect blend of comfort and convenience awaits. Enjoy stunning one and two-bedroom floor plans featuring lofty vaulted ceilings, natural light, and private balconies. Dive into a lifestyle enriched by amenities like a refreshing pool, fitness center, and charming picnic areas. Join our vibrant community today!",
  "property_applynow_blurb": "At Harbin Pointe in Bentonville, AR, modern living meets thoughtful amenities, from a sparkling pool and tennis courts to an invigorating fitness center. Choose from one or two-bedroom floor plans, each featuring natural light and upgraded finishes. Lease online today and elevate your lifestyle in this vibrant community!",
  "property_contactus_blurb": "At Harbin Pointe in Bentonville, AR, our diverse floor plans include inviting one-bedroom and spacious two-bedroom apartments designed for your lifestyle. Each layout offers modern comfort and style, making it easy to find your perfect home. Curious to know more? Reach out to our leasing team today!",
  "property_faqs_blurb": "At Harbin Pointe in Bentonville, AR, our thoughtfully designed one-bedroom and two-bedroom floor plans offer comfort and style tailored to your lifestyle. Have questions? Our FAQs page is the perfect resource for insights on community living and amenities. Your ideal home is just a click away!",
  "property_floorplans_blurb": "At Harbin Pointe in Bentonville, AR, find the ideal blend of comfort and style with our thoughtfully designed one and two-bedroom floor plans. Each space reflects a modern lifestyle, catering to your every need. Browse our available apartment homes today and unearth your perfect fit!",
  "property_gallery_blurb": "At Harbin Pointe in Bentonville, AR, vibrant living awaits. Choose from spacious one or two-bedroom floor plans, each adorned with designer accents and abundant natural light. Enjoy amenities like a sparkling pool, fitness center, and serene walking trails. Picture yourself thriving in this lively community, where every detail is tailored for you!",
  "property_interactivemap_blurb": "At Harbin Pointe in Bentonville, AR, your perfect home awaits amid scenic walking trails, vibrant communal spaces, and a variety of modern floor plans. With amenities like a fitness center and pet play area, living here means embracing comfort and community. Check our interactive map to find your ideal space!",
  "property_pets_blurb": "At Harbin Pointe in Bentonville, AR, your furry friends are just as important as you are! With space for up to two pets per home, our pet-friendly community ensures that every wag and purr feels right at home. Enjoy your life together in a vibrant neighborhood designed for all.",
  "property_referafriend_blurb": "At Harbin Pointe in Bentonville, AR, your perfect living space awaits! Choose from our inviting one and two-bedroom floor plans designed for comfort and style. Great friends make great neighbors—refer a friend today and experience the charm of community living together! ",
  "property_residentaccess_blurb": "Welcome to Harbin Pointe in Bentonville, AR, where comfort meets convenience. Choose from stylish one and two-bedroom floor plans tailored for your lifestyle. Access your resident portal today to manage rent, schedule maintenance, and stay connected to your community. Your hassle-free living experience awaits!",
  "property_reviews_blurb": "At Harbin Pointe in Bentonville, AR, residents rave about their vibrant community atmosphere, stating it's \"the perfect blend of comfort and convenience.\" Experience exceptional living where neighbors become friends. Curious about what else they love? Dive into our reviews and discover the warmth of our community!",
  "property_created_at": "1771540046569",
  "property_scheduletour_blurb": "At Harbin Pointe in Bentonville, AR, spacious one and two-bedroom floor plans cater to your lifestyle desires. Experience an inviting community where every corner reflects comfort and style. Interested in firsthand insights? Schedule a tour and uncover why our residents love calling Harbin Pointe home!",
  "property_thankyou_blurb": "Thank you for reaching out to Harbin Pointe in Bentonville, AR! We’re excited to help you find your perfect home, whether it's a cozy one-bedroom retreat or a spacious two-bedroom haven. Keep an eye on your inbox; a friendly team member will be in touch soon to assist you!",
  "property_virtualtours_blurb": "At Harbin Pointe in Bentonville, AR, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Experience vibrant living spaces and lush community amenities. Ready to see it all? Take a virtual tour today and envision your new home at Harbin Pointe!",
  "property_copyright": "2026 All Rights Reserved. Harbin Pointe",
  "property_seo_title_home": "Bentonville Apartments - Modern Comforts at Harbin Pointe, AR",
  "property_seo_description_home": "Enjoy pet-friendly living and flexible leases near Walmart and Crystal Bridges at Harbin Pointe apartments in Bentonville, AR.",
  "property_seo_title_floorplans": "Spacious Floor Plans - Harbin Pointe Apartments Bentonville AR",
  "property_seo_description_floorplans": "Modern one- and two-bedroom apartments with walk-in closets and private patios in Bentonville, AR. Choose your perfect Harbin Pointe layout.",
  "property_seo_title_amenities": "Premium Amenities - Harbin Pointe Apartments Bentonville AR",
  "property_seo_description_amenities": "Enjoy a sparkling pool, dog park, garage options, and in-home laundry at Harbin Pointe Apartments in Bentonville, AR.",
  "property_seo_title_gallery": "Photo Gallery - Harbin Pointe Apartments Bentonville AR",
  "property_seo_description_gallery": "Explore Harbin Pointe's photo gallery - see stylish apartments, modern kitchens, and resort-style amenities in Bentonville, AR.",
  "property_seo_title_virtualtours": "Virtual Tour - Harbin Pointe Apartments Bentonville AR",
  "property_seo_description_virtualtours": "Explore Harbin Pointe Apartments in Bentonville, AR from home with a virtual tour. Discover the community online.",
  "property_seo_title_interactivemap": "Interactive Map | Harbin Pointe Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Harbin Pointe in Bentonville, AR. Use our interactive map for available apartments and amenities designed for your lifestyle!",
  "property_seo_title_neighborhood": "Bentonville Neighborhood - Harbin Pointe Apartments AR",
  "property_seo_description_neighborhood": "Live near downtown, top employers, highways, and shopping at Harbin Pointe Apartments in Bentonville, AR.",
  "property_seo_title_contact": "Contact Harbin Pointe Apartments in Bentonville, AR",
  "property_seo_description_contact": "Connect with the Harbin Pointe Apartments leasing team in Bentonville, AR. We're here to help with your move.",
  "property_seo_title_faqs": "FAQs | Apartments in Bentonville, AR",
  "property_seo_description_faqs": "Unlock answers to your questions about Harbin Pointe! From floor plans to amenities, find everything you need to know about life in Bentonville.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bentonville, AR",
  "property_seo_description_reviews": "Join the Harbin Pointe community in Bentonville, AR! Experience exceptional amenities and vibrant living—see what our residents love about their homes!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bentonville, AR",
  "property_seo_description_applynow": "Discover your ideal apartment at Harbin Pointe, Bentonville! Enjoy upscale amenities like a pool and dog park. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Harbin Pointe",
  "property_seo_description_residentaccess": "Enjoy convenience at Harbin Pointe! Access your resident portal for rent payments, maintenance requests, and more from home in Bentonville, AR.",
  "property_seo_title_referafriend": "Refer A Friend | Harbin Pointe",
  "property_seo_description_referafriend": "Bring your friends home to Harbin Pointe in Bentonville! Great friends make great neighbors—refer today and enjoy the joy of shared living.",
  "property_seo_title_scheduletour": "Schedule a Tour - Harbin Pointe Apartments Bentonville AR",
  "property_seo_description_scheduletour": "Tour options available for Harbin Pointe Apartments in Bentonville, AR. Choose the best way to visit your new home.",
  "property_seo_title_privacy": "Privacy Policy | Harbin Pointe",
  "property_seo_description_privacy": "At Harbin Pointe, your privacy matters. Dive into our policy for peace of mind in Bentonville, AR. Your sanctuary, your data – safeguarded.",
  "property_seo_title_accessibility": "Website Accessibility | Harbin Pointe",
  "property_seo_description_accessibility": "Experience accessibility for all at Harbin Pointe in Bentonville, AR. We prioritize digital inclusion, ensuring every resident feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Harbin Pointe",
  "property_seo_description_sitemap": "Unveil the best of Harbin Pointe! Navigate our Bentonville community's offerings effortlessly with our sitemap—your gateway to luxury living.",
  "property_seo_title_thankyou": "Thank You | Harbin Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Harbin Pointe in Bentonville! Our team is excited to assist you on your journey to finding the perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bentonville, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293613235",
  "amenities": [
    {
      "id": "ec_69108564de6690c36f09ba48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89542227",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d9a38-9b0f-71eb-996a-f64c1795e454.webp",
      "amenity_image_media": {
        "alt_text": "Playground in front of apartment buildings",
        "public_id": "019d9a38-9b0f-71eb-996a-f64c1795e454",
        "storage_key": "property/6767906449167212/019d9a38-9b0f-71eb-996a-f64c1795e454.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "an image of a playground in front of an apartment building,an empty playground in front of an apartment building",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d8c61e2a25d29e1ee4e30c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426362",
      "title": "Resort-style swimming pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d9a38-a91c-744d-b592-7079d976adce.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019d9a38-a91c-744d-b592-7079d976adce",
        "storage_key": "property/6767906449167212/019d9a38-a91c-744d-b592-7079d976adce.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "our apartments have an outdoor pool with lounge chairs,our apartments feature a swimming pool with an apartment building in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_385e35f86d571d806b5a981f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426363",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d9a38-9bc5-74d5-b028-1099b0e0c6d8.webp",
      "amenity_image_media": {
        "alt_text": "Tennis court on a multifamily property with apartment buildings in the background.",
        "public_id": "019d9a38-9bc5-74d5-b028-1099b0e0c6d8",
        "storage_key": "property/6767906449167212/019d9a38-9bc5-74d5-b028-1099b0e0c6d8.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "a sidewalk leading to a tennis court in front of an apartment building,an empty tennis court with apartments in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21cdb30da6484f95a639d27f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426365",
      "title": "24-hour fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d9a38-b759-750d-a066-0a195f1c244a.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, weight machines, and exercise balls.",
        "public_id": "019d9a38-b759-750d-a066-0a195f1c244a",
        "storage_key": "property/6767906449167212/019d9a38-b759-750d-a066-0a195f1c244a.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "our gym is equipped with state of the art equipment including cardio machines and weights,a gym with weights and cardio machines and a large window,a gym with weights and exercise equipment and windows",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4035f298af9dee083f9f523",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426367",
      "title": "Attached/Detached Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-f1bb-74af-987a-a02695bd697a.webp",
      "amenity_image_media": {
        "alt_text": "Car wash facility with multiple garage bays.",
        "public_id": "019d0222-f1bb-74af-987a-a02695bd697a",
        "storage_key": "property/6767906449167212/019d0222-f1bb-74af-987a-a02695bd697a.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "a parking garage with a blue sign on the side of it",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_561dcef2a596cb0e54bb3e14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426364",
      "title": "Off Leash Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_820207f1825099b7d0c24d7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426366",
      "title": "Coffee/tea bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-effb-7256-93cf-ba16d0ff5973.webp",
      "amenity_image_media": {
        "alt_text": "Community kitchen with island seating and coffee station",
        "public_id": "019d0222-effb-7256-93cf-ba16d0ff5973",
        "storage_key": "property/6767906449167212/019d0222-effb-7256-93cf-ba16d0ff5973.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "an open kitchen and living room with a large island with bar stools",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3929bea38d20dce29a55c066",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426368",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7260cb94303d8878c57906fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664624",
      "title": "Storage Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8b54afd11fa00af6abf88b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "124800056",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_888fc3289a11458021f8c3d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426371",
      "title": "Beautiful Wood-Style Vinyl Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e738b5c91245659b48c920b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426372",
      "title": "Walk-in closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d9a38-90a8-725b-b502-3a7db08d5446.webp",
      "amenity_image_media": {
        "alt_text": "Walk-in closet with wire shelving",
        "public_id": "019d9a38-90a8-725b-b502-3a7db08d5446",
        "storage_key": "property/6767906449167212/019d9a38-90a8-725b-b502-3a7db08d5446.webp",
        "width": 3072,
        "height": 2036
      },
      "amenity_image_alt_text": "Harbin Pointe Walk In Closets",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_696487122d7f91fc52a87510",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426373",
      "title": "Private Balcony/Patio*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff9103ab66146042dbefcbc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89580429",
      "title": "In-Home Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-f01b-70f4-9aa3-6fd1a732f46e.webp",
      "amenity_image_media": {
        "alt_text": "Washer, dryer, and electrical panel in laundry closet.",
        "public_id": "019d0222-f01b-70f4-9aa3-6fd1a732f46e",
        "storage_key": "property/6767906449167212/019d0222-f01b-70f4-9aa3-6fd1a732f46e.webp",
        "width": 3072,
        "height": 2036
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbbb057c87b056d617f89c7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89426374",
      "title": "Light-filled rooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b59bcb46b420d257c7965f7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664626",
      "title": "Kitchen Bar Top",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_684bc3aefc5d63db9d5d2859",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664629",
      "title": "Juliet Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfa3b3f0b5773530d18b38ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664630",
      "title": "Breakfast Nook*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_244cbd1dc31949e51693c78e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664632",
      "title": "Natural Light from Oversized Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d205f8325e869393b9cd1afe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664633",
      "title": "Additional Storage Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_643e7071f7011555f60eee77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664634",
      "title": "Designer Two-Tone Painted Accent Walls",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a226c950a34e698841a60017",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664636",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a9cc1974f5e3973697795fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664637",
      "title": "Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e451f71ffd2164a006c3c49a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "89664639",
      "title": "Newly Updated Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39c0b0cd8eb31b06fa6444fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "yardi",
      "external_id": "120640145",
      "title": "*In select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_f7533e0a05e433e9ab4b5260",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-0489-703a-962e-1a29e6d60291.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, accent chairs, coffee table, and artwork.",
        "public_id": "019fb1aa-0489-703a-962e-1a29e6d60291",
        "storage_key": "property/6767906449167212/019fb1aa-0489-703a-962e-1a29e6d60291.webp",
        "width": 2752,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, two accent chairs, a modern coffee table, and decorative wall art, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room with gray sofa, accent chairs, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (28).jpg"
    },
    {
      "id": "ec_fb427ad8c7ff28ac15a98326",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-185a-74ea-9d20-6bde88d917c4.webp",
      "image_media": {
        "alt_text": "Living room with a sofa and coffee table, and an open kitchen with white cabinets and a stainless steel stove.",
        "public_id": "019fb1aa-185a-74ea-9d20-6bde88d917c4",
        "storage_key": "property/6767906449167212/019fb1aa-185a-74ea-9d20-6bde88d917c4.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Apartment",
      "description": "Spacious living room with a comfortable sofa and modern kitchen featuring white cabinetry and stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room with a sofa and coffee table, and an open kitchen with white cabinets and a stainless steel stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (29).jpg"
    },
    {
      "id": "ec_0e6c87cc1919018dd1a6e223",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-17a5-73bc-9b63-2b95640b8d14.webp",
      "image_media": {
        "alt_text": "Kitchen sink and counter with a view of the living area and two windows.",
        "public_id": "019fb1aa-17a5-73bc-9b63-2b95640b8d14",
        "storage_key": "property/6767906449167212/019fb1aa-17a5-73bc-9b63-2b95640b8d14.webp",
        "width": 2167,
        "height": 1219
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a sleek faucet and spacious counter, opening up to a bright living area with ample natural light from two large windows.",
      "link": "false",
      "alt_text": "Kitchen sink and counter with a view of the living area and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (30).jpg"
    },
    {
      "id": "ec_a317f24904d0dcc87342ea8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-17a2-7260-b017-25ac90f47cb2.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and dining area with light gray walls and wood-look flooring.",
        "public_id": "019fb1aa-17a2-7260-b017-25ac90f47cb2",
        "storage_key": "property/6767906449167212/019fb1aa-17a2-7260-b017-25ac90f47cb2.webp",
        "width": 2334,
        "height": 1313
      },
      "title": "Apartment",
      "description": "Spacious kitchen and dining area with a breakfast bar, contemporary finishes, and ample natural light. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern apartment kitchen and dining area with light gray walls and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (31).jpg"
    },
    {
      "id": "ec_f046aff5e7c72dcc5cab7ee7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-17a5-73bc-9b63-2fa36361e756.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment kitchen and living area with white cabinets and a kitchen island.",
        "public_id": "019fb1aa-17a5-73bc-9b63-2fa36361e756",
        "storage_key": "property/6767906449167212/019fb1aa-17a5-73bc-9b63-2fa36361e756.webp",
        "width": 2167,
        "height": 1219
      },
      "title": "Apartment",
      "description": "Open-concept living area featuring a modern kitchen with white cabinetry, stainless steel appliances, and a spacious island, perfect for entertaining.",
      "link": "false",
      "alt_text": "Interior view of an apartment kitchen and living area with white cabinets and a kitchen island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (32).jpg"
    },
    {
      "id": "ec_35296778d9beadf92bd8e21b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-863b-721d-9b94-a5fcb9b859ab.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living area with a door leading outside.",
        "public_id": "019d0222-863b-721d-9b94-a5fcb9b859ab",
        "storage_key": "property/6767906449167212/019d0222-863b-721d-9b94-a5fcb9b859ab.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Bright and airy apartment living space with large windows and a door to the outdoors. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living area with a door leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (33).jpg"
    },
    {
      "id": "ec_c15b63c982e0967a5a1ec7e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-8604-73ea-9076-6606da0ba582.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area of an apartment.",
        "public_id": "019d0222-8604-73ea-9076-6606da0ba582",
        "storage_key": "property/6767906449167212/019d0222-8604-73ea-9076-6606da0ba582.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinets and stainless steel appliances, open to the living area.",
      "link": "false",
      "alt_text": "Kitchen and living room area of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (34).jpg"
    },
    {
      "id": "ec_ff9563ca59381d97de0331ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-8ffd-7701-9a34-42cf5abee64e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink.",
        "public_id": "019d0222-8ffd-7701-9a34-42cf5abee64e",
        "storage_key": "property/6767906449167212/019d0222-8ffd-7701-9a34-42cf5abee64e.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious and modern kitchen, featuring ample cabinet space, sleek countertops, and stainless steel appliances. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (35).jpg"
    },
    {
      "id": "ec_747785ab9d3b2816ba06dc38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-905a-7698-bfa3-2abc97910fa8.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and bathroom",
        "public_id": "019d0222-905a-7698-bfa3-2abc97910fa8",
        "storage_key": "property/6767906449167212/019d0222-905a-7698-bfa3-2abc97910fa8.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and an en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with closet and bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (36).jpg"
    },
    {
      "id": "ec_4c926b70d172fa5ae9fddf47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-9449-71ef-8180-2e3eddaae3c1.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and a ceiling fan.",
        "public_id": "019d0222-9449-71ef-8180-2e3eddaae3c1",
        "storage_key": "property/6767906449167212/019d0222-9449-71ef-8180-2e3eddaae3c1.webp",
        "width": 2334,
        "height": 1313
      },
      "title": "Apartment",
      "description": "A bright and airy bedroom featuring plush carpeting, a large window with blinds, and a ceiling fan, offering a comfortable and serene living space.",
      "link": "false",
      "alt_text": "Empty bedroom with a window and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (37).jpg"
    },
    {
      "id": "ec_0a476d97af09ddcf5385fc1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019fb1aa-242c-70fc-bee1-9cb8ffbad7e3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with shower, vanity, and toilet. Features a welcome home sign.",
        "public_id": "019fb1aa-242c-70fc-bee1-9cb8ffbad7e3",
        "storage_key": "property/6767906449167212/019fb1aa-242c-70fc-bee1-9cb8ffbad7e3.webp",
        "width": 2334,
        "height": 1313
      },
      "title": "Apartment",
      "description": "Enjoy a fresh, modern bathroom experience with a sleek vanity, spacious shower, and convenient toilet. A \"Welcome Home!\" sign adds a warm touch.",
      "link": "false",
      "alt_text": "Modern bathroom with shower, vanity, and toilet. Features a welcome home sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (38).jpg"
    },
    {
      "id": "ec_6d8ac445ec4fe93976ed8375",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-971e-743b-9ee6-fad37336c5ec.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room with a shelf with a note on it.",
        "public_id": "019d0222-971e-743b-9ee6-fad37336c5ec",
        "storage_key": "property/6767906449167212/019d0222-971e-743b-9ee6-fad37336c5ec.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry days, complete with a shelf for storage.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry room with a shelf with a note on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (39).jpg"
    },
    {
      "id": "ec_d7d8022cbdd719be958725b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-9b39-73eb-9c77-c75ef7b49875.webp",
      "image_media": {
        "alt_text": "Front door of apartment unit 2, with a welcome mat.",
        "public_id": "019d0222-9b39-73eb-9c77-c75ef7b49875",
        "storage_key": "property/6767906449167212/019d0222-9b39-73eb-9c77-c75ef7b49875.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to your new home! This inviting front entrance features a charming brick exterior and a freshly painted black door.",
      "link": "false",
      "alt_text": "Front door of apartment unit 2, with a welcome mat.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (40).jpg"
    },
    {
      "id": "ec_f4206f7f415ad14f6edc3835",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-a00d-777a-bada-bec1e506338c.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge area.",
        "public_id": "019d0222-a00d-777a-bada-bec1e506338c",
        "storage_key": "property/6767906449167212/019d0222-a00d-777a-bada-bec1e506338c.webp",
        "width": 3072,
        "height": 2035
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Apartment complex swimming pool with lounge area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (41).jpg"
    },
    {
      "id": "ec_1623312dd83523349961da46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-a1cd-77be-b791-4c67214d928e.webp",
      "image_media": {
        "alt_text": "Apartment complex with a pool and lounge chairs.",
        "public_id": "019d0222-a1cd-77be-b791-4c67214d928e",
        "storage_key": "property/6767906449167212/019d0222-a1cd-77be-b791-4c67214d928e.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling blue pool, surrounded by comfortable lounge chairs and beautiful landscaping.",
      "link": "false",
      "alt_text": "Apartment complex with a pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (42).jpg"
    },
    {
      "id": "ec_919942b1ef3760eae7dcaf57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-a33d-7201-a424-84281477a2cf.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartments in the background.",
        "public_id": "019d0222-a33d-7201-a424-84281477a2cf",
        "storage_key": "property/6767906449167212/019d0222-a33d-7201-a424-84281477a2cf.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. Surrounded by comfortable lounge chairs and beautiful apartment buildings, this is the ultimate community amenity.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartments in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (43).jpg"
    },
    {
      "id": "ec_acc0eebf5a34127a8d30f9ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-a82c-74cb-9d64-8ca828417594.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and lounge chairs in front of an apartment building.",
        "public_id": "019d0222-a82c-74cb-9d64-8ca828417594",
        "storage_key": "property/6767906449167212/019d0222-a82c-74cb-9d64-8ca828417594.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in our community's well-appointed grilling and lounge area, perfect for socializing and unwinding.",
      "link": "false",
      "alt_text": "Outdoor seating area with grills and lounge chairs in front of an apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (44).jpg"
    },
    {
      "id": "ec_c3cfff48cd60f068a1d3f71c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-ac72-757c-ab81-3fba5b3c5237.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight machines, and free weights.",
        "public_id": "019d0222-ac72-757c-ab81-3fba5b3c5237",
        "storage_key": "property/6767906449167212/019d0222-ac72-757c-ab81-3fba5b3c5237.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment for a great workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (45).jpg"
    },
    {
      "id": "ec_ca6dea03dd3669329774c5fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-adf3-7378-96b5-0cbbc4ee5fd7.webp",
      "image_media": {
        "alt_text": "Tennis court at apartment complex",
        "public_id": "019d0222-adf3-7378-96b5-0cbbc4ee5fd7",
        "storage_key": "property/6767906449167212/019d0222-adf3-7378-96b5-0cbbc4ee5fd7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a game of tennis on our well-maintained court, perfect for residents looking for an active lifestyle.",
      "link": "false",
      "alt_text": "Tennis court at apartment complex",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (46).jpg"
    },
    {
      "id": "ec_aac5a3ecd90cdd2efbf829ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-b23b-70aa-9fdd-159c389b975e.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a large island and bar stools, overlooking a pool area.",
        "public_id": "019d0222-b23b-70aa-9fdd-159c389b975e",
        "storage_key": "property/6767906449167212/019d0222-b23b-70aa-9fdd-159c389b975e.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy our modern kitchen and dining space, perfect for entertaining, with views of the sparkling pool. A great community amenity for residents.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a large island and bar stools, overlooking a pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (47).jpg"
    },
    {
      "id": "ec_1b22eda25094368dc2880baa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-b966-71b3-b152-a985ca88a2fc.webp",
      "image_media": {
        "alt_text": "Lobby lounge area with a large sectional sofa, armchairs, coffee tables, and a chandelier.",
        "public_id": "019d0222-b966-71b3-b152-a985ca88a2fc",
        "storage_key": "property/6767906449167212/019d0222-b966-71b3-b152-a985ca88a2fc.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating and a stylish ambiance.",
      "link": "false",
      "alt_text": "Lobby lounge area with a large sectional sofa, armchairs, coffee tables, and a chandelier.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (48).jpg"
    },
    {
      "id": "ec_4cf0cf2475a339221797b321",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-ba38-755a-8e2e-fe595a1f2d17.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs under a covered patio with a pergola.",
        "public_id": "019d0222-ba38-755a-8e2e-fe595a1f2d17",
        "storage_key": "property/6767906449167212/019d0222-ba38-755a-8e2e-fe595a1f2d17.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Enjoy dining al fresco or relaxing outdoors in our charming community seating area, featuring comfortable tables and chairs under a shaded pergola.",
      "link": "false",
      "alt_text": "Outdoor seating area with tables and chairs under a covered patio with a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (49).jpg"
    },
    {
      "id": "ec_59c2ae58727f0ab85fa6c8ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-bfb3-758e-96ef-f0b185190647.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a playground in the foreground.",
        "public_id": "019d0222-bfb3-758e-96ef-f0b185190647",
        "storage_key": "property/6767906449167212/019d0222-bfb3-758e-96ef-f0b185190647.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our apartment community's playground, located right outside your door. Perfect for families and a great addition to our vibrant community spaces.",
      "link": "false",
      "alt_text": "Apartment building exterior with a playground in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (50).jpg"
    },
    {
      "id": "ec_74b9dbdde81b9c783fd4f5e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-c46e-7358-8825-6da09c159132.webp",
      "image_media": {
        "alt_text": "Building exterior with manicured lawns, flower beds, and landscaping.",
        "public_id": "019d0222-c46e-7358-8825-6da09c159132",
        "storage_key": "property/6767906449167212/019d0222-c46e-7358-8825-6da09c159132.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Beautifully maintained building exterior with lush greenery and vibrant flower beds, creating an inviting and welcoming atmosphere.",
      "link": "false",
      "alt_text": "Building exterior with manicured lawns, flower beds, and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (51).jpg"
    },
    {
      "id": "ec_02db52cba3f4b475f3603173",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0222-c6fc-743d-83ac-58e889acf41e.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a pond and grassy area in the foreground.",
        "public_id": "019d0222-c6fc-743d-83ac-58e889acf41e",
        "storage_key": "property/6767906449167212/019d0222-c6fc-743d-83ac-58e889acf41e.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with a scenic pond and lush green grounds.",
      "link": "false",
      "alt_text": "Apartment buildings with a pond and grassy area in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AR_Harbin-Pointe_Favorites (52).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c3d20223-3e0e-4057-ab9a-ebfe748d35ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "7 Brew Coffee",
      "poi_type": "Restaurants",
      "poi_address": "2903 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Drive-thru coffee shop chain also offering Italian sodas, smoothies, energy drinks and milkshakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-566a-755f-8518-d032a33d7b14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-566a-755f-8518-d032a33d7b14",
        "storage_key": "property/6767906449167212/019d0223-566a-755f-8518-d032a33d7b14.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://7brew.com/location/arkansas-bentonville-001009",
      "poi_directions_map_url": "https://maps.google.com/?cid=12231163994271918353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-brew-coffee",
      "poi_latitude": "36.357154",
      "poi_longitude": "-94.244161",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-448-2068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-4292f5219796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-4292f5219796",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-4292f5219796.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJTc79FPkPyYcRESkgbNnSvak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_54900f48-1f70-4f8c-a3ba-8f22f90b032c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The Buttered Biscuit",
      "poi_type": "Restaurants",
      "poi_address": "1001 SW Regional Airport Blvd #17, Bentonville, AR 72712, USA",
      "poi_short_description": "Southern-style breakfast comfort food (think chicken and waffles and biscuits and gravy) for dine-in or catering.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-549b-71bc-9fec-a45cf34fe1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-549b-71bc-9fec-a45cf34fe1e6",
        "storage_key": "property/6767906449167212/019d0223-549b-71bc-9fec-a45cf34fe1e6.webp",
        "width": 1024,
        "height": 676
      },
      "poi_business_url": "https://thebutteredbiscuit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13042852348134474560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-buttered-biscuit",
      "poi_latitude": "36.3351063",
      "poi_longitude": "-94.2244869",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-364-0080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK4NAFu0RyYcRQMNsTBuFAbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b2758f71-eeb5-4702-9dde-f9e6b8b86894",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Stone Mill Cafe - Bentonville",
      "poi_type": "Restaurants",
      "poi_address": "2903 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Casual eatery specializing in breakfast fare, sandwiches, soups and salads.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-56a6-7187-8278-8f2cdb3e04ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-56a6-7187-8278-8f2cdb3e04ed",
        "storage_key": "property/6767906449167212/019d0223-56a6-7187-8278-8f2cdb3e04ed.webp",
        "width": 1280,
        "height": 678
      },
      "poi_business_url": "https://www.stonemillcafebentonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9272861340411694123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stone-mill-cafe---bentonville",
      "poi_latitude": "36.34193399999999",
      "poi_longitude": "-94.2104366",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-210-2017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxep8moQyYcRKwyxZkLSr4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a1baf28a-641f-40e1-bae7-d9954316a42b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Gusano's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "2905 S Walton Blvd #9, Bentonville, AR 72712, USA",
      "poi_short_description": "Casual pizza joint with a sports-bar vibe dishing up Chicago-style pies plus weekday lunch specials.",
      "poi_long_description": "Casual pizza joint with a sports-bar vibe dishing up Chicago-style pies plus weekday lunch specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-5656-7722-b594-1b5930b86888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-5656-7722-b594-1b5930b86888",
        "storage_key": "property/6767906449167212/019d0223-5656-7722-b594-1b5930b86888.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gusanos.pizza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10663710658308816451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gusanos-pizzeria",
      "poi_latitude": "36.3417372",
      "poi_longitude": "-94.2096328",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-271-8242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRo6e2oQyYcRQz4LUFgc_ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_62b8bf61-1da2-41d4-bf18-dae66492247f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Ozark Mountain Bagel Co",
      "poi_type": "Restaurants",
      "poi_address": "214 SE Walton Ave Suite 14, Bentonville, AR 72712, USA",
      "poi_short_description": "Bagel shop serving breakfast and lunch, including gluten-free options, plus sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-5c95-70ff-8fa9-46b64f8a89ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-5c95-70ff-8fa9-46b64f8a89ca",
        "storage_key": "property/6767906449167212/019d0223-5c95-70ff-8fa9-46b64f8a89ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ozarkmountainbagelco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1256288709456562576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ozark-mountain-bagel-co",
      "poi_latitude": "36.3347443",
      "poi_longitude": "-94.208147",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-319-6688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44rIpUYQyYcRkAl-1uw7bxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_91dfe83e-e901-499b-a99c-455dc7b5e9d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Thai Basil Bentonville",
      "poi_type": "Restaurants",
      "poi_address": "3301 S Walton Blvd #25, Bentonville, AR 72712, USA",
      "poi_short_description": "Familiar favorites like curries & noodle stir-fries in a brightly painted, casual dining room.",
      "poi_long_description": "Familiar favorites like curries & noodle stir-fries in a brightly painted, casual dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-5c87-76ee-abbb-baa453c9942b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-5c87-76ee-abbb-baa453c9942b",
        "storage_key": "property/6767906449167212/019d0223-5c87-76ee-abbb-baa453c9942b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.thaibasilllc.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18408663744161621681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-basil-bentonville",
      "poi_latitude": "36.3386192",
      "poi_longitude": "-94.2100825",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-273-3955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxmsUkAQyYcRsaZdXCS2eP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_0494a65d-63d0-4708-b3dc-ec3ec6eb3ab5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Flavors Indian Cuisine & Lounge",
      "poi_type": "Restaurants",
      "poi_address": "211 SE Walton Blvd Suite # 100, Bentonville, AR 72712, USA",
      "poi_short_description": "Warm, relaxed shopping-plaza spot serving traditional Indian dishes, plus imported & craft beers.",
      "poi_long_description": "Warm, relaxed shopping-plaza spot serving traditional Indian dishes, plus imported & craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-5dc5-74bc-ad3b-102ffbcdcb88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-5dc5-74bc-ad3b-102ffbcdcb88",
        "storage_key": "property/6767906449167212/019d0223-5dc5-74bc-ad3b-102ffbcdcb88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flavorsindiancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14486725241878414800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flavors-indian-cuisine--lounge",
      "poi_latitude": "36.3361295",
      "poi_longitude": "-94.2084152",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-254-1035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_tOFUAQyYcR0AXZgNovC8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_829001ac-1b2b-4dbf-87ab-cb4c2cb93f6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The Hive",
      "poi_type": "Restaurants",
      "poi_address": "200 NE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Elevated, locally sourced Arkansas fare served within the sleek, modern 21c Museum Hotel.",
      "poi_long_description": "Elevated, locally sourced Arkansas fare served within the sleek, modern 21c Museum Hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-5d43-7363-b808-608704230e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-5d43-7363-b808-608704230e52",
        "storage_key": "property/6767906449167212/019d0223-5d43-7363-b808-608704230e52.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.thehivebentonville.com/menu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6854281461056587573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hive",
      "poi_latitude": "36.3739649",
      "poi_longitude": "-94.2078824",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-286-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_rw-5kayYcRNcfSXKxMH18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6be8b888-6472-465c-9235-755ff4b78e5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Yeyo's El Alma de Mexico",
      "poi_type": "Restaurants",
      "poi_address": "801 SE 8th St Suite 41, Bentonville, AR 72712, USA",
      "poi_short_description": "Family-run eatery for tacos, burritos & other Mexican staples made with area-sourced ingredients.",
      "poi_long_description": "Family-run eatery for tacos, burritos & other Mexican staples made with area-sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-629a-72b7-9d0f-d81d2699241b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-629a-72b7-9d0f-d81d2699241b",
        "storage_key": "property/6767906449167212/019d0223-629a-72b7-9d0f-d81d2699241b.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://www.yeyosnwa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12108803933400893926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yeyos-el-alma-de-mexico",
      "poi_latitude": "36.3653363",
      "poi_longitude": "-94.2001993",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-657-6954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJa83VIIayYcR5ok2sQUdC6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7e5f1aa4-7121-45bf-ba9c-9a214cb15d7d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Onyx Coffee Lab",
      "poi_type": "Restaurants",
      "poi_address": "100 NW 2nd St Suite 106, Bentonville, AR 72712, USA",
      "poi_short_description": "Coffeehouse providing espresso drinks made with locally roasted, carefully sourced beans.",
      "poi_long_description": "Coffeehouse providing espresso drinks made with locally roasted, carefully sourced beans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-639e-730c-b67e-80c74e081898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-639e-730c-b67e-80c74e081898",
        "storage_key": "property/6767906449167212/019d0223-639e-730c-b67e-80c74e081898.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://onyxcoffeelab.com/pages/bentonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=14017669312028229279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onyx-coffee-lab",
      "poi_latitude": "36.3731117",
      "poi_longitude": "-94.2092746",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-715-6492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-4292f5219796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-4292f5219796",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-4292f5219796.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJa00m55kayYcRnz5WcvjDiMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1ecc1263-b344-4a48-a1a0-fc1f1a4f08ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Meaux Beignet",
      "poi_type": "Restaurants",
      "poi_address": "901 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-643b-70d7-a6a5-1dbc7aa5fbc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-643b-70d7-a6a5-1dbc7aa5fbc7",
        "storage_key": "property/6767906449167212/019d0223-643b-70d7-a6a5-1dbc7aa5fbc7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10099259327734530683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meaux-beignet",
      "poi_latitude": "36.3562666",
      "poi_longitude": "-94.221086",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdQb6nMbyYcRe8IqtNnGJ4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_76fbff34-4811-4e90-ac9b-8cdba3b75304",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Flying Fish",
      "poi_type": "Restaurants",
      "poi_address": "109A NW 2nd St, Bentonville, AR 72712, USA",
      "poi_short_description": "Laid-back eatery serving seafood with a Cajun twist, from fried catfish to po' boy sandwiches.",
      "poi_long_description": "Laid-back eatery serving seafood with a Cajun twist, from fried catfish to po' boy sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-6527-700c-b3ca-bbe7f397d5ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-6527-700c-b3ca-bbe7f397d5ee",
        "storage_key": "property/6767906449167212/019d0223-6527-700c-b3ca-bbe7f397d5ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flyingfishinthe.net/bentonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1360223897958363992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-fish",
      "poi_latitude": "36.372836",
      "poi_longitude": "-94.209599",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-657-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSN42pkayYcRWDPOrG184BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_7979baf6-f17e-415c-aa39-3e104dcfb714",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The Preacher's Son",
      "poi_type": "Restaurants",
      "poi_address": "201 NW A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Refined New American plates in the serene atmosphere of a restored Gothic Revival church.",
      "poi_long_description": "Refined New American plates in the serene atmosphere of a restored Gothic Revival church.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-680c-71e9-aa65-72cf31caa837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-680c-71e9-aa65-72cf31caa837",
        "storage_key": "property/6767906449167212/019d0223-680c-71e9-aa65-72cf31caa837.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.thepreachersson.com/?y_source=1_MjAzNDAxNzk1MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10152112371664247505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-preachers-son",
      "poi_latitude": "36.3731948",
      "poi_longitude": "-94.2104842",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-445-6065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy047K5gayYcR0Vrl8GmM44w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fb807beb-bef2-47f8-81b7-c900776fbe9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Vivace Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "1100 SE 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Refined Mediterranean & Middle Eastern plates presented in a warm, relaxed atmosphere.",
      "poi_long_description": "Refined Mediterranean & Middle Eastern plates presented in a warm, relaxed atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-6921-728d-b9a7-b02da98efcb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-6921-728d-b9a7-b02da98efcb8",
        "storage_key": "property/6767906449167212/019d0223-6921-728d-b9a7-b02da98efcb8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18148560231268191207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vivace-mediterranean-cuisine",
      "poi_latitude": "36.3560885",
      "poi_longitude": "-94.1961569",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-273-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRR7anwQyYcR54uFCWCj3Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_323a156b-d651-4f94-abbb-d1547717add5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "906 SW Regional Airport Blvd, Bentonville, AR 72713, USA",
      "poi_short_description": "Chain of grocery stores carrying baked goods, electronics, clothing and other household items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-6b65-74ac-8819-163178277db3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-6b65-74ac-8819-163178277db3",
        "storage_key": "property/6767906449167212/019d0223-6b65-74ac-8819-163178277db3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4686-bentonville-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570164248636695790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.3371876",
      "poi_longitude": "-94.2239398",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-268-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-ba55-7558-8355-b269e264b126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-ba55-7558-8355-b269e264b126",
        "storage_key": "property/6767906449167212/019d0223-ba55-7558-8355-b269e264b126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB30C4yIQyYcR7iR6zuNVFNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bb634da4-1217-4c68-a1fd-754356dca85a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1006 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-6b84-728e-9d82-dbd4f11008d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-6b84-728e-9d82-dbd4f11008d8",
        "storage_key": "property/6767906449167212/019d0223-6b84-728e-9d82-dbd4f11008d8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.aldi.us/stores/l/ar/bentonville/1006-sw-14th-street/f289",
      "poi_directions_map_url": "https://maps.google.com/?cid=11311701847499853259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.3576485",
      "poi_longitude": "-94.2239907",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-ba55-7558-8355-b269e264b126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-ba55-7558-8355-b269e264b126",
        "storage_key": "property/6767906449167212/019d0223-ba55-7558-8355-b269e264b126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ026o7fkRyYcRy81b-eU8-5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_5898ec0a-b365-4409-ae83-fd800013ada5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Harps Food Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "1209 N Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Grocery store chain selling fresh produce and meats from local sources, as well as featuring a bakery, a deli and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-6daf-72bf-9b1d-a243391bcc71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-6daf-72bf-9b1d-a243391bcc71",
        "storage_key": "property/6767906449167212/019d0223-6daf-72bf-9b1d-a243391bcc71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.harpsfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7362598520817777792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harps-food-stores",
      "poi_latitude": "36.3869344",
      "poi_longitude": "-94.2224888",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-273-2245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-ba55-7558-8355-b269e264b126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-ba55-7558-8355-b269e264b126",
        "storage_key": "property/6767906449167212/019d0223-ba55-7558-8355-b269e264b126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZZE55kayYcRgPwokVg0LWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_01dcb8d8-e6cc-445c-913f-540069921593",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1311 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-6e51-7027-973f-88cedaf8c8a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-6e51-7027-973f-88cedaf8c8a9",
        "storage_key": "property/6767906449167212/019d0223-6e51-7027-973f-88cedaf8c8a9.webp",
        "width": 1280,
        "height": 682
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1311+s+walton+blvd-bentonville-ar-72712/id=16021",
      "poi_directions_map_url": "https://maps.google.com/?cid=4100844392678524795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.357476",
      "poi_longitude": "-94.2125239",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-268-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszouW8YayYcRe4fBeD8g6Tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8bf30608-149e-466a-8ebb-5616f02c6e6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Maverik",
      "poi_type": "Shopping & Retail",
      "poi_address": "3610 SW Regional Airport Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_long_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7076-756b-8bb2-1c5094c6cfc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7076-756b-8bb2-1c5094c6cfc6",
        "storage_key": "property/6767906449167212/019d0223-7076-756b-8bb2-1c5094c6cfc6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.maverik.com/ar/bentonville/3610-sw-regional-airport-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=12732764882362153851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik",
      "poi_latitude": "36.3368997",
      "poi_longitude": "-94.2535208",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 479-254-3759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf2f-764f-a989-257d6f523918.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf2f-764f-a989-257d6f523918",
        "storage_key": "property/6767906449167212/019d0223-bf2f-764f-a989-257d6f523918.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHX8cz9wPyYcRe7vDDTPes7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_6fc1ee42-7b1e-4ef2-aa86-8f5a7e32bb88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Phillips 66",
      "poi_type": "Shopping & Retail",
      "poi_address": "689 SW Regional Airport Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Convenience store offering hot food, drinks, snacks and gas, plus friendly staff, but some customers complain about faulty pumps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7122-75ae-871e-02cae5e7e043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7122-75ae-871e-02cae5e7e043",
        "storage_key": "property/6767906449167212/019d0223-7122-75ae-871e-02cae5e7e043.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.phillips66gas.com/station/p66-bentonville-66-0000906147/?utm_source=G&utm_medium=local&utm_campaign=google-local&utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17349577856642563777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "36.3352926",
      "poi_longitude": "-94.2193998",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-367-2419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf2f-764f-a989-257d6f523918.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf2f-764f-a989-257d6f523918",
        "storage_key": "property/6767906449167212/019d0223-bf2f-764f-a989-257d6f523918.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJUXdjY6MRyYcRwb4pfCMVxvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_237f954a-8411-4e72-8ca9-3b739c4ee249",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Casey's",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_long_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-729f-7634-b771-7770d26aaca8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-729f-7634-b771-7770d26aaca8",
        "storage_key": "property/6767906449167212/019d0223-729f-7634-b771-7770d26aaca8.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.caseys.com/general-store/ar-bentonville/900-sw-14th-st/3022?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304238172571829688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caseys",
      "poi_latitude": "36.3577896",
      "poi_longitude": "-94.2214531",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-464-9849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cf-75ac-91a1-3f62da5c34c5",
        "storage_key": "property/6767906449167212/019d0223-b9cf-75ac-91a1-3f62da5c34c5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2MctwgQyYcRuAWmMrWVGRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_570007fe-0abb-404e-9e23-e459b2317ba9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "406 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Market stocking foods, produce and sundry items, along with electronics, cleaning and hardware items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7377-735d-8756-1ba4fc5aa743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7377-735d-8756-1ba4fc5aa743",
        "storage_key": "property/6767906449167212/019d0223-7377-735d-8756-1ba4fc5aa743.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/100-bentonville-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9489717797594232404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.3681884",
      "poi_longitude": "-94.2242442",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-273-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf33-75a3-abff-a3ea84249842",
        "storage_key": "property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA3fmOK8ayYcRVHZO6A5AsoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6123c75f-82ad-46a8-81a5-ad4aaae47a7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "3500 SE Club Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-75a7-72cf-8cab-7a9dae83ac25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-75a7-72cf-8cab-7a9dae83ac25",
        "storage_key": "property/6767906449167212/019d0223-75a7-72cf-8cab-7a9dae83ac25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.samsclub.com/club/4969-bentonville-ar",
      "poi_directions_map_url": "https://maps.google.com/?cid=11461601690814428863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "36.3519444",
      "poi_longitude": "-94.1713889",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-621-5537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf33-75a3-abff-a3ea84249842",
        "storage_key": "property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6R_YWb0QyYcRv7YC-gLKD58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_4b472fd9-4e80-4983-a87e-f68f23a03dee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Marshalls & HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "202 S Promenade Blvd, Rogers, AR 72756, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7634-72f8-9097-3d1fc92d7734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7634-72f8-9097-3d1fc92d7734",
        "storage_key": "property/6767906449167212/019d0223-7634-72f8-9097-3d1fc92d7734.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12287333107077923524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls--homegoods",
      "poi_latitude": "36.3337249",
      "poi_longitude": "-94.1765975",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-936-8758",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf33-75a3-abff-a3ea84249842",
        "storage_key": "property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFx69B0VuyYcRxMJGHFxghao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3f69b96f-f24c-4c83-8168-a9c0f966e39c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Willowbrook Elementary School",
      "poi_type": "Education",
      "poi_address": "1800 SW Gator Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14814824237174807204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willowbrook-elementary-school",
      "poi_latitude": "36.3224601",
      "poi_longitude": "-94.2336502",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-418-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK-QLYSoQyYcRpNqmwibUmM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_436ea0df-93d8-4217-ad2c-8a38f27a7bc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Creekside Middle School",
      "poi_type": "Education",
      "poi_address": "2901 SW 28th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/o/cms",
      "poi_directions_map_url": "https://maps.google.com/?cid=11771632093884437944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creekside-middle-school",
      "poi_latitude": "36.3416066",
      "poi_longitude": "-94.2424056",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-286-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgc4ROuYPyYcRuNWRRgU9XaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6f67fc35-39f1-48e8-851a-ea260bc6510c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Fulbright Junior High Schools",
      "poi_type": "Education",
      "poi_address": "5303 SW Bright Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-77c5-72cf-855a-4a32266fd08c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-77c5-72cf-855a-4a32266fd08c",
        "storage_key": "property/6767906449167212/019d0223-77c5-72cf-855a-4a32266fd08c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bentonvillek12.org/o/fjhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=5399851991371823668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fulbright-junior-high-schools",
      "poi_latitude": "36.3201751",
      "poi_longitude": "-94.2354949",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-802-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAe0JFNUPyYcRNDpnycYg8Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0345dfdb-fb5b-4bf0-a09e-785b09bf22d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Bentonville High School",
      "poi_type": "Education",
      "poi_address": "1801 SE J St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/o/bhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=11218002166020631332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-high-school",
      "poi_latitude": "36.35172420000001",
      "poi_longitude": "-94.1954077",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-254-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD7qEvmIQyYcRJOs404hZrps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_71634de2-3e35-47ab-81b4-8590d14f632f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Vaughn Elementary School",
      "poi_type": "Education",
      "poi_address": "5301 SW Barron Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7885-7428-97aa-3a4cb2b05a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7885-7428-97aa-3a4cb2b05a36",
        "storage_key": "property/6767906449167212/019d0223-7885-7428-97aa-3a4cb2b05a36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bentonvillek12.org/o/ves",
      "poi_directions_map_url": "https://maps.google.com/?cid=15389496529305207992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vaughn-elementary-school",
      "poi_latitude": "36.3220941",
      "poi_longitude": "-94.2941467",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-254-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMdPSvMUPyYcRuARYbY55ktU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_30286958-e43f-437e-83d2-18c8c3da2e7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Ruth Barker Middle School",
      "poi_type": "Education",
      "poi_address": "500 SE 18th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13487145960687035214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruth-barker-middle-school",
      "poi_latitude": "36.3517081",
      "poi_longitude": "-94.2043471",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-696-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7dUOKG4QyYcRTmOYFMv3K7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7431f3f4-834f-453d-a388-92388b08da95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "NorthWest Arkansas Community College",
      "poi_type": "Education",
      "poi_address": "1 College Dr, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7ae7-7430-8bdd-4c7ca75f5590.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7ae7-7430-8bdd-4c7ca75f5590",
        "storage_key": "property/6767906449167212/019d0223-7ae7-7430-8bdd-4c7ca75f5590.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.nwacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8062833287412958226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-arkansas-community-college",
      "poi_latitude": "36.358598",
      "poi_longitude": "-94.172471",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-986-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3NSpZgQyYcREsRx-yfw5G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0b35085b-177a-49de-b233-b89c1dba53c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Noah's Ark Learning Center",
      "poi_type": "Education",
      "poi_address": "200 SW A St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fbcbentonville.org/noahs-ark",
      "poi_directions_map_url": "https://maps.google.com/?cid=1744442629193392178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noahs-ark-learning-center",
      "poi_latitude": "36.3712705",
      "poi_longitude": "-94.2111862",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-271-6624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzZML-JgayYcRMuAeLFSBNRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_6cc6a6ab-5d30-4b5a-9bc2-f24bd2d297d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Sugar Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "1102 Bella Vista Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=929873777427690471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugar-creek-elementary-school",
      "poi_latitude": "36.3838171",
      "poi_longitude": "-94.2161167",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-254-5790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX-8rWb8ayYcR5zOHHUaT5ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_eb4be6e4-933f-44aa-bd5c-d5e51df8ba30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Thomas Jefferson Elementary School",
      "poi_type": "Education",
      "poi_address": "810 Bella Vista Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18318035873287712294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-jefferson-elementary-school",
      "poi_latitude": "36.3824961",
      "poi_longitude": "-94.216271",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-254-5860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQefg274ayYcRJi4t2pK8Nv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_38533266-7e4b-4834-b707-a613b553b3d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Crystal Bridges Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "600 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Renowned collection ranging from Rockwell to Warhol in a striking structure set on 120 lush acres.",
      "poi_long_description": "Renowned collection ranging from Rockwell to Warhol in a striking structure set on 120 lush acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7c33-75ce-88e7-9f1b35a9124e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7c33-75ce-88e7-9f1b35a9124e",
        "storage_key": "property/6767906449167212/019d0223-7c33-75ce-88e7-9f1b35a9124e.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://crystalbridges.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12476663502294684731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-bridges-museum-of-american-art",
      "poi_latitude": "36.3818542",
      "poi_longitude": "-94.2026525",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-418-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf31-77fe-8b23-896596b05b15",
        "storage_key": "property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5IzxBQayYcROxRb5FkDJq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_9fa92e8a-02a3-4308-9a16-ef074690978f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The Momentary",
      "poi_type": "Entertainment",
      "poi_address": "507 SE E St, Bentonville, AR 72712, USA",
      "poi_short_description": "Free-admission extension of the Crystal Bridges Museum focusing on contemporary art and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7d5a-721b-b393-b7106710549a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7d5a-721b-b393-b7106710549a",
        "storage_key": "property/6767906449167212/019d0223-7d5a-721b-b393-b7106710549a.webp",
        "width": 836,
        "height": 627
      },
      "poi_business_url": "https://themomentary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2949730782627288492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-momentary",
      "poi_latitude": "36.3665519",
      "poi_longitude": "-94.2026659",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-367-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx-8ypwayYcRrNWIuYSM7yg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_fb10dbad-9fe5-4af6-9029-4874e35e91b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Scott Family Amazeum",
      "poi_type": "Entertainment",
      "poi_address": "1009 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Modern children's museum offering dynamic, hands-on displays & activities & an outdoor \"playscape.\"",
      "poi_long_description": "Modern children's museum offering dynamic, hands-on displays & activities & an outdoor \"playscape.\"",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-7f5e-728c-a151-0db838aa802c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-7f5e-728c-a151-0db838aa802c",
        "storage_key": "property/6767906449167212/019d0223-7f5e-728c-a151-0db838aa802c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.amazeum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3620504812667872326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scott-family-amazeum",
      "poi_latitude": "36.3792428",
      "poi_longitude": "-94.1972494",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-696-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf31-77fe-8b23-896596b05b15",
        "storage_key": "property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcoHrI4ayYcRRiSp4vGdPjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_eaf7e65a-ae63-4eb5-91ad-6ed5e19534ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "21c Museum Hotel Bentonville",
      "poi_type": "Entertainment",
      "poi_address": "200 NE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Hip lodging inside a contemporary art museum, plus a gym, loaner bikes & a gourmet restaurant/bar.",
      "poi_long_description": "Hip lodging inside a contemporary art museum, plus a gym, loaner bikes & a gourmet restaurant/bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-825c-73a6-9806-05c5a3bfd2ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-825c-73a6-9806-05c5a3bfd2ec",
        "storage_key": "property/6767906449167212/019d0223-825c-73a6-9806-05c5a3bfd2ec.webp",
        "width": 1280,
        "height": 845
      },
      "poi_business_url": "https://www.21cmuseumhotels.com/bentonville?utm_source=google&utm_medium=organic&utm_campaign=gmb-website&utm_content=website_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=2168657143112449453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "21c-museum-hotel-bentonville",
      "poi_latitude": "36.3740903",
      "poi_longitude": "-94.2078794",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-286-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c47d-75fe-b724-b2ad8bc5e7f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c47d-75fe-b724-b2ad8bc5e7f9",
        "storage_key": "property/6767906449167212/019d0223-c47d-75fe-b724-b2ad8bc5e7f9.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJtQtoTZcayYcRrb3Ufi6eGB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_be6c51a6-5997-4940-aaaf-2a93407aff0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The Walmart Museum",
      "poi_type": "Entertainment",
      "poi_address": "105 N Main St, Bentonville, AR 72712, USA",
      "poi_short_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_long_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8349-76ba-a744-c8b667870aa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8349-76ba-a744-c8b667870aa9",
        "storage_key": "property/6767906449167212/019d0223-8349-76ba-a744-c8b667870aa9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.walmartmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5406846993405692822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walmart-museum",
      "poi_latitude": "36.37245410000001",
      "poi_longitude": "-94.2089508",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-273-1329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf31-77fe-8b23-896596b05b15",
        "storage_key": "property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVzPwpkayYcRlsvVnLH6CEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_93037e91-34bb-4bf8-9082-7ad403fa06c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Museum of Native American History",
      "poi_type": "Entertainment",
      "poi_address": "202 SW O St, Bentonville, AR 72712, USA",
      "poi_short_description": "Museum tracing Native American history through displays of pottery, attire, tools & other artifacts.",
      "poi_long_description": "Museum tracing Native American history through displays of pottery, attire, tools & other artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8331-76eb-b6b7-543cf67a3ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8331-76eb-b6b7-543cf67a3ba9",
        "storage_key": "property/6767906449167212/019d0223-8331-76eb-b6b7-543cf67a3ba9.webp",
        "width": 1125,
        "height": 633
      },
      "poi_business_url": "http://monah.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4935111507607127021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-native-american-history",
      "poi_latitude": "36.3714449",
      "poi_longitude": "-94.2311562",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-273-2456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf31-77fe-8b23-896596b05b15",
        "storage_key": "property/6767906449167212/019d0223-bf31-77fe-8b23-896596b05b15.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJPTZsdK0ayYcR7YPd0cQJfUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b9656fb3-76e4-4fce-b28d-797e75db0e3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "8th Street Market",
      "poi_type": "Entertainment",
      "poi_address": "801 SE 8th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Vibrant hub for dining and food trucks, featuring several restaurants.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-84c2-77ab-9dc5-ae4d270c008c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-84c2-77ab-9dc5-ae4d270c008c",
        "storage_key": "property/6767906449167212/019d0223-84c2-77ab-9dc5-ae4d270c008c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.visitbentonville.com/listing/8th-street-market/586/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16946389685358510000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8th-street-market",
      "poi_latitude": "36.364829",
      "poi_longitude": "-94.2002037",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf33-75a3-abff-a3ea84249842",
        "storage_key": "property/6767906449167212/019d0223-bf33-75a3-abff-a3ea84249842.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwctOWIIayYcRsD8jDaKrLes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_1f8eb196-e186-439c-b0c5-3ebd080a265e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Bentonville Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "901 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-87e2-71ec-beb4-06fb1404df17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-87e2-71ec-beb4-06fb1404df17",
        "storage_key": "property/6767906449167212/019d0223-87e2-71ec-beb4-06fb1404df17.webp",
        "width": 1000,
        "height": 553
      },
      "poi_business_url": "https://bentonvillebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16300324017488664510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-brewing-company",
      "poi_latitude": "36.356613",
      "poi_longitude": "-94.2212277",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-903-7330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRtR6IMayYcRvhcuwlRiNuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_e4939fa0-7c14-47ab-a9f5-ce127590e699",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The Walmart AMP",
      "poi_type": "Entertainment",
      "poi_address": "5079 W Northgate Rd, Rogers, AR 72758, USA",
      "poi_short_description": "This sizable music venue with a range of outdoor seating options hosts many touring artists.",
      "poi_long_description": "This sizable music venue with a range of outdoor seating options hosts many touring artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8a29-74ff-b923-1f56cb8592a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8a29-74ff-b923-1f56cb8592a0",
        "storage_key": "property/6767906449167212/019d0223-8a29-74ff-b923-1f56cb8592a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://walmartamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4073090213928832597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walmart-amp",
      "poi_latitude": "36.302676",
      "poi_longitude": "-94.183726",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-443-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYU0xw0RyYcRVQ5ZK_iFhjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_e02a6c84-805a-4899-910f-302fd9a1751e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Railyard Live at Butterfield Stage",
      "poi_type": "Entertainment",
      "poi_address": "101 E Cherry St, Rogers, AR 72756, USA",
      "poi_short_description": "Open-air venue for local and touring bands, with occasional gigs and lawn seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8a14-7461-89f6-abfe463fe70e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8a14-7461-89f6-abfe463fe70e",
        "storage_key": "property/6767906449167212/019d0223-8a14-7461-89f6-abfe463fe70e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.railyardlive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11856565126968184658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "railyard-live-at-butterfield-stage",
      "poi_latitude": "36.3305721",
      "poi_longitude": "-94.1157446",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 479-621-1186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9q5TdYXyYcRUg85CSr7iqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_e194dd46-4c24-49d8-80d9-7d634c01c157",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Northwest Medical Center - Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 Medical Center Pkwy, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8a29-74ff-b923-20fb71322029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8a29-74ff-b923-20fb71322029",
        "storage_key": "property/6767906449167212/019d0223-8a29-74ff-b923-20fb71322029.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.northwesthealth.com/nmc-bentonville?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12521861175053738530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-medical-center---bentonville",
      "poi_latitude": "36.3401491",
      "poi_longitude": "-94.1912939",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-553-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c4a9-7529-bc86-3fc74546b243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c4a9-7529-bc86-3fc74546b243",
        "storage_key": "property/6767906449167212/019d0223-c4a9-7529-bc86-3fc74546b243.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdkIQPUQyYcRImLVIWWWxq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_2df5e9cf-a971-4800-8f15-5c6edc5ae14d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Washington Regional Urgent Care - Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8c7e-729a-b1df-81990fc48ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8c7e-729a-b1df-81990fc48ec2",
        "storage_key": "property/6767906449167212/019d0223-8c7e-729a-b1df-81990fc48ec2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urgentteam.com/locations/washington-regional-urgent-care-bentonville-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7074006900970683400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-regional-urgent-care---bentonville",
      "poi_latitude": "36.3578506",
      "poi_longitude": "-94.2133293",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-367-3078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxwRUMH4RyYcRCPwE98vrK2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5f6dbae6-cf42-4233-bd38-a4282d71f3df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 N Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-8fa8-742f-a92b-bb777be89f7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-8fa8-742f-a92b-bb777be89f7f",
        "storage_key": "property/6767906449167212/019d0223-8fa8-742f-a92b-bb777be89f7f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/4376-bentonville-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15786628929554206006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "36.3892889",
      "poi_longitude": "-94.2206514",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-268-9830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c510-73f9-abd8-ebd01c506b08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c510-73f9-abd8-ebd01c506b08",
        "storage_key": "property/6767906449167212/019d0223-c510-73f9-abd8-ebd01c506b08.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTSXesYayYcRNs37yl5fFds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5b3717ad-77bb-475d-b7f9-05a82d488ffc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Bentonville Community Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 SW Citizens Cir, Bentonville, AR 72712, USA",
      "poi_short_description": "Clean community center featuring a lap pool, a kids-only pool and an outdoor playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-90d7-740c-bc7f-af46ecb1fae6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-90d7-740c-bc7f-af46ecb1fae6",
        "storage_key": "property/6767906449167212/019d0223-90d7-740c-bc7f-af46ecb1fae6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bentonvillear.com/359/Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17378480803937372516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-community-center",
      "poi_latitude": "36.3309331",
      "poi_longitude": "-94.225257",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-696-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13SsDCUQyYcRZMmhTjfELPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_a2bc37f4-0a2f-4d64-946a-7a9714b0f0ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1001 SW Westpark Dr, Bentonville, AR 72712, USA",
      "poi_short_description": "Chain fitness center offering a non-intimidating environment, tanning, and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9096-7638-abdd-2f5aab6ecc57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9096-7638-abdd-2f5aab6ecc57",
        "storage_key": "property/6767906449167212/019d0223-9096-7638-abdd-2f5aab6ecc57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bentonville-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093251464599536686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.3585652",
      "poi_longitude": "-94.2225918",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-255-5756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwee1LQYQyYcRLoTho6RtN-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_26330a6b-3397-4c60-9cef-39d8dc034169",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "YogaSix Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "1110 SE 28th St Suite 20, Bentonville, AR 72712, USA",
      "poi_short_description": "Studio offering yoga classes (including hot yoga) for all skill levels, as well as workshops.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-928b-7699-9875-09ee3b51e434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-928b-7699-9875-09ee3b51e434",
        "storage_key": "property/6767906449167212/019d0223-928b-7699-9875-09ee3b51e434.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.yogasix.com/bentonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=2917262757111473666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-bentonville",
      "poi_latitude": "36.3421849",
      "poi_longitude": "-94.1954681",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-364-0298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuRtkkIgbyYcRAiYbcgUzfCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_0313f30b-65dd-4462-b384-4e3d4d0dfee4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Unscripted Joy",
      "poi_type": "Health and Wellness",
      "poi_address": "4101 SW Pointe Rd #204, Bentonville, AR 72713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9679-735c-b8e4-b87211c70627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9679-735c-b8e4-b87211c70627",
        "storage_key": "property/6767906449167212/019d0223-9679-735c-b8e4-b87211c70627.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17597452076641332059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unscripted-joy",
      "poi_latitude": "36.3312273",
      "poi_longitude": "-94.2171674",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 512-965-9159",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRxz3Zu4RyYcRW6sqrG21NvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_a03bfde2-e943-407d-a729-7c4b3d7f01f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "The J Street Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "2614 SE J St, Bentonville, AR 72712, USA",
      "poi_short_description": "Gym with a focus on bodybuilding featuring a sauna and a wide range of high-quality equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9761-736b-9d6c-bea4f96b93ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9761-736b-9d6c-bea4f96b93ba",
        "storage_key": "property/6767906449167212/019d0223-9761-736b-9d6c-bea4f96b93ba.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.jstreetgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3168697202124163501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-j-street-gym",
      "poi_latitude": "36.3437442",
      "poi_longitude": "-94.1978578",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-721-6707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-tMsqwRyYcRrYliHVF5-Ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5359353a-1391-414f-94f2-0cda39554f47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Sundar Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "1205 SE 33rd St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9655-730f-89ef-3ee67b585fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9655-730f-89ef-3ee67b585fe3",
        "storage_key": "property/6767906449167212/019d0223-9655-730f-89ef-3ee67b585fe3.webp",
        "width": 1170,
        "height": 879
      },
      "poi_business_url": "https://sundaryoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8232776977401835080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sundar-yoga",
      "poi_latitude": "36.338319",
      "poi_longitude": "-94.194648",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 414-687-7079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-6BDxrkRyYcRSO4MtQqzQHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_f84d389e-fcc4-4faf-8919-634b3b1b736e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Creekside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3104 SW Bright Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "Park featuring a splash pad, picnic tables, and playground, plus pickleball courts and a dog area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9ac7-72c9-8ea7-a5f8be45a0e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9ac7-72c9-8ea7-a5f8be45a0e5",
        "storage_key": "property/6767906449167212/019d0223-9ac7-72c9-8ea7-a5f8be45a0e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12297997079495963118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creekside-park",
      "poi_latitude": "36.340913",
      "poi_longitude": "-94.2367634",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c50e-720b-8039-aa1725e129d0",
        "storage_key": "property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBykAOrUPyYcR7vElrC9Dq6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_db353d3f-8d08-4a72-9762-40218a1afb63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Osage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 SW 16th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Urban park featuring a dog park, archery and pickleball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9caa-77e9-9fc8-8b1b9739870e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9caa-77e9-9fc8-8b1b9739870e",
        "storage_key": "property/6767906449167212/019d0223-9caa-77e9-9fc8-8b1b9739870e.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.peelcompton.org/osage-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16508715315507867151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osage-park",
      "poi_latitude": "36.354941",
      "poi_longitude": "-94.2160107",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-254-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c50e-720b-8039-aa1725e129d0",
        "storage_key": "property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3704YsRyYcRD67lzhy9GuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_68255e28-5b47-4413-88ff-ef2b690d70d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Lake Bentonville Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2100 SW I St, Bentonville, AR 72712, USA",
      "poi_short_description": "Airplanes and a lake feature at this lakeside playground with rope climbs, slides and shady areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9c94-72db-abee-bd2eeef9718b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9c94-72db-abee-bd2eeef9718b",
        "storage_key": "property/6767906449167212/019d0223-9c94-72db-abee-bd2eeef9718b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18128752639016206763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-bentonville-playground",
      "poi_latitude": "36.3511499",
      "poi_longitude": "-94.2215695",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxt5l10RyYcRq4F8lXlElvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_2b41b55c-4d9a-45a5-8698-06350fb84cda",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Coler Mountain Bike Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 NW 3rd St, Bentonville, AR 72712, USA",
      "poi_short_description": "Relaxed, 340-acre mountain bike preserve with miles of trails, plus a playground, a cafeand camping.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-9da3-774f-b1a0-bf6697a301b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-9da3-774f-b1a0-bf6697a301b4",
        "storage_key": "property/6767906449167212/019d0223-9da3-774f-b1a0-bf6697a301b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.peelcompton.org/coler-mountain-bike-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8725155075528542573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coler-mountain-bike-preserve",
      "poi_latitude": "36.3768479",
      "poi_longitude": "-94.2402353",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-507-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c50e-720b-8039-aa1725e129d0",
        "storage_key": "property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5_LaSwFyYcRbUkTN1D6FXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4fe42fe8-b3f6-4edd-aab2-997da0bb79ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Compton Gardens & Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "312 N Main St, Bentonville, AR 72712, USA",
      "poi_short_description": "Hiking and biking trails wind through these botanical gardens featuring labeled plants and benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a02a-71e9-925a-f6831ec6aa71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a02a-71e9-925a-f6831ec6aa71",
        "storage_key": "property/6767906449167212/019d0223-a02a-71e9-925a-f6831ec6aa71.webp",
        "width": 800,
        "height": 504
      },
      "poi_business_url": "https://www.peelcompton.org/compton-gardens-arboretum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=970442275906507774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "compton-gardens--arboretum",
      "poi_latitude": "36.3766381",
      "poi_longitude": "-94.208183",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-254-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYiMR5EayYcR_tNtuhu0dw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_ad7a0a4e-55a0-4a4f-925d-0cfdb8c1c225",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Peel Museum & Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Former 19th-century home now serving as a botanical garden, event venue, and museum.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a0f1-774c-b72b-92263875fe3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a0f1-774c-b72b-92263875fe3d",
        "storage_key": "property/6767906449167212/019d0223-a0f1-774c-b72b-92263875fe3d.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://www.peelcompton.org/peel-museum-botanical-garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960123937017476129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peel-museum--botanical-garden",
      "poi_latitude": "36.3690562",
      "poi_longitude": "-94.2223038",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-273-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5IwkqUayYcRIbQuyKYuGpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_b33cb368-4e73-4b84-a0e5-6a6e3381785b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Bark Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 N Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Clean fenced dog park with areas for small and large breeds, and an agility area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a1b3-759c-bdc6-45e6ce14d701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a1b3-759c-bdc6-45e6ce14d701",
        "storage_key": "property/6767906449167212/019d0223-a1b3-759c-bdc6-45e6ce14d701.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bentonvillear.com/781/Bark-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7567765367181735802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bark-park",
      "poi_latitude": "36.4033824",
      "poi_longitude": "-94.215765",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c50e-720b-8039-aa1725e129d0",
        "storage_key": "property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ847LA98ayYcRevdedoEaBmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d0afbc1c-a7d9-49dd-9c35-2162779527f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Citizens Park Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1101 SW Citizens Cir, Bentonville, AR 72712, USA",
      "poi_short_description": "Clean, spacious playground featuring a zip line, plus swings and slides for children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a392-71d7-ab41-634192b29b3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a392-71d7-ab41-634192b29b3f",
        "storage_key": "property/6767906449167212/019d0223-a392-71d7-ab41-634192b29b3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bentonvillear.com/1052/Citizens-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11069421024971769419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citizens-park-playground",
      "poi_latitude": "36.3299753",
      "poi_longitude": "-94.2267651",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXG16P8RyYcRS8auHsZ7npk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_7a551ece-4bba-4934-916b-bb4787b5cb9c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "401 NE Martin Luther King Jr Pkwy, Bentonville, AR 72712, USA",
      "poi_short_description": "73-acre park with an Olympic-sized pool & diving pool, plus a ball field & other sports facilities.",
      "poi_long_description": "73-acre park with an Olympic-sized pool & diving pool, plus a ball field & other sports facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a4d4-702b-80d6-332b0ee7f514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a4d4-702b-80d6-332b0ee7f514",
        "storage_key": "property/6767906449167212/019d0223-a4d4-702b-80d6-332b0ee7f514.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bentonvillear.com/773/Memorial-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1539943602156584218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "36.3741091",
      "poi_longitude": "-94.1877789",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c50e-720b-8039-aa1725e129d0",
        "storage_key": "property/6767906449167212/019d0223-c50e-720b-8039-aa1725e129d0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUxiUGMayYcRGr2tFIz6XhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7400fb6a-b76b-481f-b329-1c6f6caf6778",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Lawrence Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "214 NE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "This area alternates between an outdoor ice rink during the winter & a summertime splash pad.",
      "poi_long_description": "This area alternates between an outdoor ice rink during the winter & a summertime splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a5ff-736a-9cdb-ad58091d33b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a5ff-736a-9cdb-ad58091d33b0",
        "storage_key": "property/6767906449167212/019d0223-a5ff-736a-9cdb-ad58091d33b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bentonvillear.com/887/The-Rink-at-Lawrence-Plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=15657218424923445304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lawrence-plaza",
      "poi_latitude": "36.3747919",
      "poi_longitude": "-94.2078198",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_92SZcayYcROFhDtDOdSdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_e4aeb2fa-f573-4fce-aff4-fdb61e7c03a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Walmart Home Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "702 SW 8th St, Bentonville, AR 72716, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a762-778e-ac17-3abede5cd208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a762-778e-ac17-3abede5cd208",
        "storage_key": "property/6767906449167212/019d0223-a762-778e-ac17-3abede5cd208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.walmart.com/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11776541477770855313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-home-office",
      "poi_latitude": "36.3652654",
      "poi_longitude": "-94.2176381",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA02d68gbyYcRkYMvSRSubqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4e9d42ed-f98f-45e6-b917-2e93082aae21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Sam's Club Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 SE Simple Savings Dr #2101, Bentonville, AR 72712, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-a925-70ce-ad1a-d0eb49e5a3b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a925-70ce-ad1a-d0eb49e5a3b2",
        "storage_key": "property/6767906449167212/019d0223-a925-70ce-ad1a-d0eb49e5a3b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/bentonville-ar-sams-club/6214",
      "poi_directions_map_url": "https://maps.google.com/?cid=2386529284113169375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-headquarters",
      "poi_latitude": "36.3459593",
      "poi_longitude": "-94.1867553",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqD4wQyYcR3_uhUb2nHiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c9aa32f4-b94b-4f23-ac24-36731b8d1cfb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "J.B. Hunt Transport Services, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 JB Hunt Corporate Dr, Lowell, AR 72745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-ab76-70e7-9f48-1b13f9b1e0f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-ab76-70e7-9f48-1b13f9b1e0f3",
        "storage_key": "property/6767906449167212/019d0223-ab76-70e7-9f48-1b13f9b1e0f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jbhunt.com/?utm_source=GoogleMyBusiness&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11570535468398063576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jb-hunt-transport-services-inc",
      "poi_latitude": "36.2447313",
      "poi_longitude": "-94.1494438",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-820-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YjK4HkUyYcR2K_shrTMkqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c3580619-ee36-4d32-b48b-8311c77f8988",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Tyson Foods World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 W Don Tyson Pkwy, Springdale, AR 72762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-acfc-7266-98f0-9a6104ad1a45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-acfc-7266-98f0-9a6104ad1a45",
        "storage_key": "property/6767906449167212/019d0223-acfc-7266-98f0-9a6104ad1a45.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.tysonfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16323102854454874636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyson-foods-world-headquarters",
      "poi_latitude": "36.1546202",
      "poi_longitude": "-94.1541342",
      "poi_miles_from_property": "17.7",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 800-643-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-b9cc-75da-8d2b-1f3d9ec97c16",
        "storage_key": "property/6767906449167212/019d0223-b9cc-75da-8d2b-1f3d9ec97c16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QqgXhdryYcRDJLyB5BPh-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d7c4d5b9-cbb0-46ec-9e27-f29feaa16514",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Mercy Hospital Northwest Arkansas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2710 S Rife Medical Ln, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-acb2-771a-8c1c-6cbe75599b4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-acb2-771a-8c1c-6cbe75599b4e",
        "storage_key": "property/6767906449167212/019d0223-acb2-771a-8c1c-6cbe75599b4e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-northwest-arkansas?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=Central&utm_content=website&y_source=1_MTI5OTY0NzItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342883712185739120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-hospital-northwest-arkansas",
      "poi_latitude": "36.3092179",
      "poi_longitude": "-94.1829407",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-338-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c4a9-7529-bc86-3fc74546b243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c4a9-7529-bc86-3fc74546b243",
        "storage_key": "property/6767906449167212/019d0223-c4a9-7529-bc86-3fc74546b243.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60dIRQURyYcRcCdxVCFzBlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_11e1754b-9540-4f11-a2cd-9fd3b9483065",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Northwest Arkansas National Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Airport Blvd, Bentonville, AR 72713, USA",
      "poi_short_description": "Domestic airport featuring a yoga room, free WiFi, an arcade & games such as chess & checkers.",
      "poi_long_description": "Domestic airport featuring a yoga room, free WiFi, an arcade & games such as chess & checkers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-ae62-7688-be1f-6e673e8ab0dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-ae62-7688-be1f-6e673e8ab0dc",
        "storage_key": "property/6767906449167212/019d0223-ae62-7688-be1f-6e673e8ab0dc.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://www.flyxna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3592327295282605376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-arkansas-national-airport",
      "poi_latitude": "36.2805838",
      "poi_longitude": "-94.3045816",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-205-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c8e2-76a2-a681-6394b133916b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c8e2-76a2-a681-6394b133916b",
        "storage_key": "property/6767906449167212/019d0223-c8e2-76a2-a681-6394b133916b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXPzbKUOyYcRQG1CYKSC2jE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6a88e756-8a46-4f4e-bbb4-716348e0b5b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "University of Arkansas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Fayetteville, AR 72701, USA",
      "poi_short_description": "This 1871 research university offers over 3 miles of sidewalk imprinted with the names of graduates.",
      "poi_long_description": "This 1871 research university offers over 3 miles of sidewalk imprinted with the names of graduates.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.uark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1198794484653892455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas",
      "poi_latitude": "36.0686895",
      "poi_longitude": "-94.1748471",
      "poi_miles_from_property": "21.6",
      "poi_walking_minutes": "7 hours 58 mins",
      "poi_biking_minutes": "2 hours 46 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 479-575-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_bwEOZuyYcRZyN-eDv5ohA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_875b5525-e253-4158-9c8d-142411af4ca4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Arkansas Children's Northwest Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2601 Gene George Blvd, Springdale, AR 72762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-b322-703a-a21f-426f1df1da21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-b322-703a-a21f-426f1df1da21",
        "storage_key": "property/6767906449167212/019d0223-b322-703a-a21f-426f1df1da21.webp",
        "width": 718,
        "height": 404
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3684343552893161194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-northwest-hospital",
      "poi_latitude": "36.1620003",
      "poi_longitude": "-94.189667",
      "poi_miles_from_property": "15.4",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 479-309-5391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-c4a9-7529-bc86-3fc74546b243.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-c4a9-7529-bc86-3fc74546b243",
        "storage_key": "property/6767906449167212/019d0223-c4a9-7529-bc86-3fc74546b243.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXS06JeJsyYcR6o6y3PBqITM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_16a5fef8-230d-427b-901a-890f4ba202d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "poi_name": "Bentonville Schools Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Tiger Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=729282564268086899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-schools-administration-building",
      "poi_latitude": "36.3864134",
      "poi_longitude": "-94.214703",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-254-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-bf35-7285-82de-fb27d49108ac",
        "storage_key": "property/6767906449167212/019d0223-bf35-7285-82de-fb27d49108ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM58nT8AayYcRc9YV2KDuHgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_289a922b4655b37c289c0b52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b179270ad9101e2324815ff2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_706333f72154a435dc4aad6c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "day": "WED",
      "open_time": "10:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f716f04445013ce3fb8f3c0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_8754cb0d9f94b67fd7f7284b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_cafc2350c8b5a680d6a75d6b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "rating": "5",
      "name": "Santosh Singh",
      "text": "Chris is truly excellent maintenance person and incredibly reliable and responsive, often addressing issues promptly and efficiently. Their technical skill is top-notch, allowing him to diagnose and fix complex problems correctly on the first visit, which saves time and money. He maintain a professional and courteous demeanor with everyone, making interactions pleasant even under stressful circumstances.",
      "date": "2025-12-05",
      "title": "false"
    },
    {
      "id": "ec_13bb12789972ba87817f03c4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "rating": "5",
      "name": "Color Haven",
      "text": "The staff Chris, Vanessa, and Denise, are always a pleasure to work with when I've had any issues. Maintenance fixes problems very quickly, and the crew is talented and dedicated. The amenities are also nice, and we feel at home here.",
      "date": "2025-11-14",
      "title": "false"
    },
    {
      "id": "ec_884df7df62e8070e3576c8fd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "rating": "5",
      "name": "Leoneida Tortolero",
      "text": "Excellent place to live, comfortable and beautiful. The maintenance team responds quickly to any request, and the new manager is doing a great job addressing residents’ issues. Highly recommended.”",
      "date": "2025-11-07",
      "title": "false"
    },
    {
      "id": "ec_551114d5da78db63d5935ccd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "rating": "5",
      "name": "Isabel Sequera",
      "text": "Very grateful for the work of Manager Julio, always attentive and kind, solving problems quickly and with dedication. Thanks to his effort, living here is a positive, safe, and pleasant experience. Also, if you have children, this place is excellent for them.",
      "date": "2025-09-22",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ea8c07eb-4958-4a9f-b803-0d420bffb135",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019f8570-6f3d-745a-8f6c-6396a5ab6a3f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8570-6f3d-745a-8f6c-6396a5ab6a3f",
        "storage_key": "property/6767906449167212/019f8570-6f3d-745a-8f6c-6396a5ab6a3f.webp",
        "width": 295,
        "height": 166
      },
      "virtual_tour_title": "Harbin Pointe",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vimeo.com/653028573?fl=pl&fe=sh"
    },
    {
      "id": "custom_7e4a62b8-3681-4ce5-81a9-df6c432408da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019f8570-252d-753b-806f-baa84a2338a1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8570-252d-753b-806f-baa84a2338a1",
        "storage_key": "property/6767906449167212/019f8570-252d-753b-806f-baa84a2338a1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Harbin Pointe | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NXrpuyGr3Va"
    },
    {
      "id": "custom_ab63211e-2779-441f-b744-2a6912eefb43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019f8570-8ce5-7238-af5c-f971f935e7d4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8570-8ce5-7238-af5c-f971f935e7d4",
        "storage_key": "property/6767906449167212/019f8570-8ce5-7238-af5c-f971f935e7d4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Harbin Pointe | Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5hxJq8pMPnM"
    },
    {
      "id": "custom_f33be4cb-9682-4432-be1b-8c852f2b45d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0224-cae5-7011-bc0a-fe25c9255e34.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and a large sink.",
        "public_id": "019d0224-cae5-7011-bc0a-fe25c9255e34",
        "storage_key": "property/6767906449167212/019d0224-cae5-7011-bc0a-fe25c9255e34.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Harbin Pointe | Creekside Classic | 1BR 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BjHuEUcdN6i"
    },
    {
      "id": "custom_d7898f93-d32f-467b-8614-4982ae99a8e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019f8570-d25c-7110-85a7-c5300c2add42.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8570-d25c-7110-85a7-c5300c2add42",
        "storage_key": "property/6767906449167212/019f8570-d25c-7110-85a7-c5300c2add42.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Harbin Pointe | 1 BR 1BA Remodel",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YtLEfGPcdHA"
    },
    {
      "id": "custom_269b73dc-c753-4c21-b389-4e877ab04cb0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019ddcfa-7be6-7469-83f7-9855214c2ca6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcfa-7be6-7469-83f7-9855214c2ca6",
        "storage_key": "property/6767906449167212/019ddcfa-7be6-7469-83f7-9855214c2ca6.webp",
        "width": 295,
        "height": 166
      },
      "virtual_tour_title": "Coler Creek Renovated",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://player.vimeo.com/video/710971140?h=63257594fd"
    }
  ],
  "faqs": [
    {
      "id": "custom_63f3fce5-bb0d-4359-8c5e-9f0cf3a634e9",
      "question": "Is there an on-site fitness facility at Harbin Pointe?",
      "answer": "Yes. Harbin Pointe has a 24-hour fitness center.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_3fc5cbaa-15bd-4ce7-ae4e-4f181fd57494",
      "question": "What major shopping and dining destinations are near Harbin Pointe?",
      "answer": "Harbin Pointe is near Promenade Mall and major retailers including Walmart, Aldi, Marshalls, and HomeGoods, with dining and other conveniences available throughout Bentonville.",
      "category": "Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_aeb7fa10-117c-47c5-8234-08a844ffaab0",
      "question": "What apartment layouts are available at Harbin Pointe?",
      "answer": "Harbin Pointe offers one- and two-bedroom apartments, with multiple floor plans in both categories.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_0c6fd7c4-ce51-45e7-9ce4-b331590506c7",
      "question": "Are laundry appliances included in the apartment homes?",
      "answer": "Yes, every apartment features a convenient in-home washer and dryer.",
      "category": "Floor Plans",
      "source": "custom"
    },
    {
      "id": "custom_6ea76370-f82d-47ef-acde-b780ed77d5c4",
      "question": "How many swimming pools are available at Harbin Pointe?",
      "answer": "Harbin Pointe has one resort-style swimming pool.",
      "category": "Amenities",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f95f3-7067-761e-a51c-2ca442217ef5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Harbin Pointe Apartment Homes Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "dog-park-apartments-bentonville-ar-harbin-pointe",
      "search_query": "dog park apartments Bentonville AR",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Bentonville, AR",
      "h2_subtitle": "Discover dog-friendly living at Harbin Pointe in Bentonville, AR. Explore nearby pet amenities including convenient dog parks.",
      "page_copy": "Welcome to Harbin Pointe, the ideal choice for those seeking dog park apartments in Bentonville, AR. Our community, located in the welcoming Outer Central Benton County, offers a pet-friendly environment with easy access to local dog parks. You and your furry friend will find a home amongst the lush surroundings and community amenities such as walking and biking trails, perfect for daily strolls or energetic runs.\n\nLiving at Harbin Pointe means convenience and comfort. Our amenities cater to both you and your pet’s needs, making life enjoyable. In addition to our nearby dog parks, residents enjoy a well-maintained on-site environment, including grilling stations and a tennis court. Plus, the additional storage closets provide ample space for all your gear. Choose Harbin Pointe and dive into a vibrant Bentonville lifestyle with unbeatable pet-friendly features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Bentonville, AR",
      "seo_description": "Discover Harbin Pointe, offering pet-friendly living in Bentonville, AR, with access to nearby dog parks and enticing community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-benton-county-harbin-pointe",
      "search_query": "apartments with in-unit laundry Benton County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Benton County",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Harbin Pointe. Located in the vibrant Benton County area, discover comfort and ease in our apartments.",
      "page_copy": "Experience ultimate convenience at Harbin Pointe, offering apartments with in-unit laundry in the heart of Benton County. Situated in Outer Central Benton County, our apartments are designed to enhance your lifestyle with modern amenities, reducing the hassles of shared laundry facilities and giving you more time to enjoy the things you love.\n\nResidents of Harbin Pointe enjoy more than just in-unit laundry; the community features numerous amenities such as maintenance on site to ensure all your needs are met. Spend your days exploring the neighborhood's walking and biking trails, or relax with friends at the community grill. If you're looking for storage solutions, our additional storage closets provide the perfect answer. At Harbin Pointe, discover a lifestyle that combines convenience and leisure in a welcoming environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Benton County",
      "seo_description": "Discover Harbin Pointe in Benton County, offering in-unit laundry and a range of amenities designed for convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "poolside-apartments-72713-harbin-pointe",
      "search_query": "poolside apartments 72713",
      "category": "Amenity",
      "h1_title": "Poolside Apartments in 72713",
      "h2_subtitle": "Cool off in style at Harbin Pointe's poolside apartments. Situated in the sought-after 72713 area, enjoy leisure and comfort every day.",
      "page_copy": "Harbin Pointe offers desirable poolside apartments in the coveted 72713 area. Nestled in the vibrant community of Outer Central Benton County, residents can unwind and relax by the pool, soaking up the sun and enjoying the serene surroundings. Our community is designed for those who appreciate easy access to leisure and recreation.\n\nIn addition to our poolside appeal, Harbin Pointe provides numerous amenities, making it a great place to call home. With on-site maintenance always ready to assist, enjoy a hassle-free lifestyle. Residents can also take advantage of the walking and biking trails, or engage in a friendly match at our tennis court. Ample additional storage ensures you have space for all your belongings. Come home to Harbin Pointe and enjoy a life of comfort and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Apartments in 72713",
      "seo_description": "Explore Harbin Pointe's poolside apartments in 72713, offering luxurious amenities and a relaxed lifestyle in Outer Central Benton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "luxury-apartments-ac-outer-central-benton-county",
      "search_query": "luxury apartments with air conditioning Outer Central Benton County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with A/C in Benton County",
      "h2_subtitle": "Enjoy luxurious living with air conditioning at Harbin Pointe. Nestled in Outer Central Benton County, experience unrivaled comfort and convenience.",
      "page_copy": "Discover Harbin Pointe, where luxury meets comfort with our air-conditioned apartments in Outer Central Benton County. Our community features modern spaces equipped with state-of-the-art air conditioning, ensuring you remain cool and comfortable no matter the season. Designed for those who appreciate an elevated living experience, our apartments capture the essence of luxury.\n\nBeyond the confines of your air-conditioned apartment, Harbin Pointe offers a suite of amenities aimed at enhancing your lifestyle. Enjoy the lush walking and biking trails, or hit the tennis courts for a game with friends. With maintenance services on site, and additional storage closets available, living here means enjoying both luxury and practicality. Choose Harbin Pointe and step into a world of exceptional living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with A/C in Benton County",
      "seo_description": "Explore luxury air-conditioned living at Harbin Pointe in Outer Central Benton County, where comfort and style blend seamlessly.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-bentonville-ar-harbin-pointe",
      "search_query": "apartments with Fitness Center Bentonville AR",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Bentonville, AR",
      "h2_subtitle": "Stay fit with ease at Harbin Pointe's on-site fitness center. Located in Bentonville, AR, our community supports both health and convenience.",
      "page_copy": "Welcome to Harbin Pointe, where you'll find apartments with a state-of-the-art fitness center, right in the heart of Bentonville, AR. Our community is perfect for those looking to maintain an active lifestyle with convenient access to fitness amenities. Located in Outer Central Benton County, our fitness center allows residents to exercise without the need for off-site gym memberships.\n\nIn addition to the fitness center, Harbin Pointe offers a wide range of amenities designed to enhance your lifestyle. Enjoy peaceful walks or bike rides along our trails, engage in friendly matches at the tennis court, or take advantage of our on-site grills for a fun weekend cookout. With maintenance always on standby and extra storage options, everything you need is catered for. Discover the perfect blend of fitness and leisure at Harbin Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Bentonville, AR",
      "seo_description": "Find your new home at Harbin Pointe, offering a fitness center and comfortable living in Bentonville, AR's Outer Central Benton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-bentonville-ar-harbin-pointe",
      "search_query": "one bedroom apartments bentonville ar",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Bentonville, AR",
      "h2_subtitle": "Discover cozy one bedroom apartments at Harbin Pointe. Located in Bentonville, AR, enjoy comfort and convenience in a vibrant community.",
      "page_copy": "Harbin Pointe invites you to explore our charming one bedroom apartments, perfect for singles or couples in Bentonville, AR. Each unit features thoughtfully designed spaces, where comfort meets functionality, ensuring you enjoy every moment at home. Situated in Outer Central Benton County, our community offers a dynamic blend of privacy and accessibility to local amenities.\n\nLiving at Harbin Pointe means more than just residing in a beautiful apartment. Our residents benefit from a myriad of on-site amenities, such as scenic walking and biking trails and enticing tennis courts. Plus, our extra storage options are perfect to keep your living space uncluttered. With dedicated maintenance available on site, enjoy a seamless living experience. Experience the lifestyle you deserve at Harbin Pointe's one bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Bentonville, AR",
      "seo_description": "Discover one bedroom living at Harbin Pointe in Bentonville, AR. Experience comfortable and convenient living in Outer Central Benton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-outer-central-benton-county",
      "search_query": "two bedroom apartments outer central benton county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Benton County",
      "h2_subtitle": "Harbin Pointe offers spacious two bedroom apartments in Outer Central Benton County. Enjoy a perfect blend of comfort and modern amenities.",
      "page_copy": "If you're searching for two bedroom apartments in Outer Central Benton County, Harbin Pointe is the perfect choice. Our spacious units are designed with both functionality and style in mind, providing ample room for families or roommates. Each apartment is thoughtfully crafted to offer a comfortable living experience, situated in a vibrant community that meets all your needs.\n\nIn addition to comfortable living spaces, Harbin Pointe offers a host of wonderful amenities such as scenic walking and biking trails, a tennis court, and additional storage closets to meet modern lifestyle demands. Our community prioritizes convenience and comfort, with maintenance on site to handle any unexpected needs. Choose the seamless harmony of modern living at Harbin Pointe's two bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Benton County",
      "seo_description": "Find your spacious two bedroom apartment at Harbin Pointe in Outer Central Benton County. Enjoy superior comfort and lifestyle amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-near-nwacc-benton-county-harbin-pointe",
      "search_query": "apartments near NorthWest Arkansas Community College Benton County",
      "category": "School",
      "h1_title": "Apartments Near NWACC in Benton County",
      "h2_subtitle": "Explore Harbin Pointe, ideally located near NorthWest Arkansas Community College. Enjoy a blend of convenience and comfort in Benton County.",
      "page_copy": "For students and staff seeking apartments near NorthWest Arkansas Community College in Benton County, Harbin Pointe offers an ideal solution. Our community provides a convenient location with easy access to NWACC, allowing you to focus on your studies or career without dealing with long commutes. Experience a lifestyle that combines both comfort and proximity at Harbin Pointe.\n\nBeyond its excellent location, our property features amenities that enhance everyday living. Enjoy peaceful walks or invigorating bike rides on our trails, or play a game of tennis on our court. Extra storage options and on-site maintenance services are just a few of the conveniences designed to make your life easier. Embrace the ease of living close to NWACC while experiencing the rich community life at Harbin Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near NWACC in Benton County",
      "seo_description": "Discover comfortable living near NorthWest Arkansas Community College at Harbin Pointe, Benton County. Convenient, well-appointed apartments await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-near-mercy-hospital-nwa-benton-county-harbin-pointe",
      "search_query": "apartments near Mercy Hospital Northwest Arkansas Benton County",
      "category": "Hospital",
      "h1_title": "Apartments Near Mercy Hospital NWA",
      "h2_subtitle": "Find comfort and convenience at Harbin Pointe, located near Mercy Hospital Northwest Arkansas in Benton County.",
      "page_copy": "Harbin Pointe offers the perfect location for those seeking apartments near Mercy Hospital Northwest Arkansas in Benton County. Our community is ideal for healthcare professionals and patients looking for a nearby residence, providing a seamless balance of convenience and peaceful living. Just a short drive from Mercy Hospital, Harbin Pointe ensures you can easily reach work or appointments without a hassle.\n\nResidents enjoy more than just proximity; the property's amenities enhance the living experience. Engage in a variety of activities with on-site walking and biking trails or enjoy the tennis court. For your convenience, additional storage spaces and dedicated maintenance are readily available. Choose Harbin Pointe for a lifestyle that marries comfort with accessibility, right in the heart of Benton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mercy Hospital NWA",
      "seo_description": "Choose Harbin Pointe for apartments near Mercy Hospital Northwest Arkansas in Benton County. Experience convenient, comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-near-mt-hebron-park-bentonville",
      "search_query": "apartments near mt hebron park bentonville",
      "category": "Park",
      "h1_title": "Apartments Near Mt Hebron Park",
      "h2_subtitle": "Live near Mt Hebron Park at Harbin Pointe. Enjoy spacious living and easy access to recreation right in Bentonville.",
      "page_copy": "For those seeking a home close to Mt Hebron Park in Bentonville, Harbin Pointe offers an ideal choice with easy park access and a tranquil setting. Our apartments blend spacious living areas with modern conveniences, perfect for nature enthusiasts who enjoy frequent visits to the nearby park. Rejuvenate with scenic views and outdoor activities right at your doorstep.\n\nHarbin Pointe is not just about location; it’s about living a rich lifestyle. Our community features a variety of amenities, including walking and biking trails that complement your active lifestyle. With a tennis court and additional storage options, we cater to diverse needs. Experience comfortable living combined with close proximity to the natural beauty of Mt Hebron Park at Harbin Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mt Hebron Park",
      "seo_description": "Discover Harbin Pointe's apartments near Mt Hebron Park in Bentonville. Enjoy spacious living with access to outdoor recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-close-to-coler-mountain-bike-preserve",
      "search_query": "apartments close to coler mountain bike preserve ar",
      "category": "Park",
      "h1_title": "Apartments Close to Coler Mountain Bike Preserve",
      "h2_subtitle": "Discover Harbin Pointe, ideally located near Coler Mountain Bike Preserve, AR. Enjoy active living with biking trails at your doorstep.",
      "page_copy": "Harbin Pointe offers a prime location for outdoor enthusiasts seeking apartments close to Coler Mountain Bike Preserve, AR. With the preserve just a short distance away, residents can indulge in thrilling bike rides or scenic walks amidst beautiful natural landscapes. Experience the perfect blend of adventure and comfort right here in Bentonville.\n\nAt Harbin Pointe, we provide more than proximity to great trails. Our community boasts its own walking and biking paths, encouraging a healthy, active lifestyle. Additional amenities include a tennis court and storage options, ensuring all your recreational and everyday needs are met. Choose Harbin Pointe, where access to Bentonville's outdoor attractions is seamlessly combined with a welcoming home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Coler Mountain Bike Preserve",
      "seo_description": "Harbin Pointe offers apartments close to Coler Mountain Bike Preserve, AR. Enjoy active living with access to bike trails and outdoor fun.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-by-osage-park-outer-central-benton-county",
      "search_query": "apartments by osage park outer central benton county",
      "category": "Park",
      "h1_title": "Apartments by Osage Park",
      "h2_subtitle": "Explore Harbin Pointe, featuring apartments by Osage Park in Outer Central Benton County. Enjoy serene living near nature's beauty.",
      "page_copy": "Discover the exceptional living experience at Harbin Pointe, perfectly situated as apartments by Osage Park in Outer Central Benton County. Osage Park offers stunning outdoor scenery and recreational activities, making it a preferred destination for relaxation and leisure. With its close proximity, Harbin Pointe residents can enjoy all that this beautiful park has to offer.\n\nHarbin Pointe not only provides a peaceful location but also enhances your daily lifestyle with numerous on-site amenities. Residents benefit from access to walking and biking trails, a fully equipped tennis court, and convenient additional storage options, along with reliable maintenance services on site. Choose Harbin Pointe for a harmonious blend of nature and modern living, right near Osage Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Osage Park",
      "seo_description": "Harbin Pointe offers apartments by Osage Park in Outer Central Benton County, providing serene living amid nature's beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-near-memorial-park-benton-county",
      "search_query": "apartments near memorial park benton county",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Park",
      "h2_subtitle": "Find comfort at Harbin Pointe, with apartments near Memorial Park in Benton County. Enjoy outdoor amenities and convenience.",
      "page_copy": "Situated near Memorial Park in Benton County, Harbin Pointe offers a unique living experience combining modern convenience with natural charm. Our apartments provide easy access to the park, known for its lush trails and open spaces perfect for relaxation or weekend picnics. Living at Harbin Pointe means enjoying the tranquility of nature just minutes from home.\n\nAt Harbin Pointe, residents can experience the best of both indoor and outdoor amenities. The community includes walking and biking trails that encourage an active lifestyle, a tennis court for recreation, and ample additional storage spaces. With maintenance on-site, your home comfort is assured. Choose Harbin Pointe, where your new apartment near Memorial Park is more than just a living space; it's a vibrant lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park",
      "seo_description": "Discover Harbin Pointe's apartments near Memorial Park in Benton County. Enjoy outdoor living with trails and recreation at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167212",
      "source": "generator",
      "page_item_url": "apartments-close-to-slaughter-pen-trail-72713",
      "search_query": "apartments close to slaughter pen trail 72713",
      "category": "Park",
      "h1_title": "Close Apartments to Slaughter Pen Trail",
      "h2_subtitle": "Reside at Harbin Pointe, offering apartments close to Slaughter Pen Trail in the 72713 area. Embrace an active lifestyle with outdoor adventures.",
      "page_copy": "Harbin Pointe provides an idyllic living option for those seeking apartments close to Slaughter Pen Trail in the 72713 area. This premier biking trail network offers a range of paths perfect for both beginners and experienced cyclists. With the trailhead practically at your doorstep, weekend adventures and daily workouts are more accessible than ever.\n\nLiving at Harbin Pointe means not sacrificing comfort for location. Our community is equipped with on-site amenities such as walking and biking trails, a tennis court, and additional storage spaces to cater to all your recreational and practical needs. Convenient maintenance services are always available, ensuring a worry-free living experience. Choose Harbin Pointe, where you can enjoy the thrill of nearby trails along with the comfort of a welcoming home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and an apartment building in the background.",
        "public_id": "019d0223-062d-737d-a062-6841605bfb5e",
        "storage_key": "property/6767906449167212/019d0223-062d-737d-a062-6841605bfb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Slaughter Pen Trail",
      "seo_description": "Harbin Pointe offers apartments close to Slaughter Pen Trail in 72713. Enjoy outdoor adventures and modern amenities at your fingertips.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309621122"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4798020445"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5KQSZ8X5"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "e266bd35-da35-4098-963b-3c44a9808c17"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3be15a6c-b6a2-49e3-a5af-c5af08082f3f/app.js?property=3be15a6c-b6a2-49e3-a5af-c5af08082f3f&propertyName=Harbin+Pointe+Apartment+Homes&channelUuid=c2491233-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlE5cERsZGJMKzI4b0M4WVFFRkNtaHc9PSIsInZhbHVlIjoiTHB6Si9uTmFzbE1mN2ZudkRHcTBEUT09IiwibWFjIjoiZmM5MjBhNWIwZDQyZGQ2Mjc0N2FhNzAxZTVhYTU2MjJhODQ2NzdjZTdjZDExZmE3NTZkMjlmNWI3YzIwMzExMyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309621122",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4798020445",
  "custom_google_gtm_id": "GTM-5KQSZ8X5",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "e266bd35-da35-4098-963b-3c44a9808c17",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/3be15a6c-b6a2-49e3-a5af-c5af08082f3f/app.js?property=3be15a6c-b6a2-49e3-a5af-c5af08082f3f&propertyName=Harbin+Pointe+Apartment+Homes&channelUuid=c2491233-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlE5cERsZGJMKzI4b0M4WVFFRkNtaHc9PSIsInZhbHVlIjoiTHB6Si9uTmFzbE1mN2ZudkRHcTBEUT09IiwibWFjIjoiZmM5MjBhNWIwZDQyZGQ2Mjc0N2FhNzAxZTVhYTU2MjJhODQ2NzdjZTdjZDExZmE3NTZkMjlmNWI3YzIwMzExMyJ9",
  "custom_audioeye_site_id": "4705527d-af6e-4f04-9c0a-932a5aec44cf",
  "custom_audioeye_site_hash": "4f3bcf3724257e8640c9818334539515"
};

export const generatedAt = '2026-10-29T21:09:37.684Z';
